import { Component, ViewChild, TemplateRef, ElementRef, OnInit } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AppService } from '../../app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from '../../support/success-snackbar/success-snackbar.component';
import { PaginationService } from '../../PaginationService';
import { messageService } from '../../message.service';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { StaticAuditTrailComponent } from 'src/app/support/static-audit-trail/static-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { DatePipe } from '@angular/common';
import { forkJoin, from, concatMap, of, Observable } from 'rxjs';

@Component({
  selector: 'app-groupusers',
  templateUrl: './groupusers.component.html',
  styleUrls: ['./groupusers.component.scss']
})

export class GroupusersComponent implements OnInit {

  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService, private readonly elem: ElementRef, private readonly datePipe: DatePipe) {
    this.message.breadcrumbData.fourthLevel = "Update Quality Group";
  };

  auditTrail: any = {};
  visibleAuditTrail: boolean = false;

  templateList: any = [];
  templateDropdown: any = [];

  selectedReviewTemplate: any = [];
  selectedApproveTemplate: any = [];
  selectedClosureReviewTemplate: any = [];
  selectedClosureApproveTemplate: any = [];

  private getCheckListTemplate(module: any): void {
    this.appService.getAllCheckListTemplateByModule(module).subscribe((templates: any) => {
      this.templateList = templates;
      this.selectBoxForTemplate();
    })
  }

  reviewSearchText: string = '';
  approveSearchText: string = '';
  closureReviewSearchText: string = '';
  closureApproveSearchText: string = '';

  @ViewChild('reviewTemplate') reviewTemplate: MatSelect;
  public isAllReviewTemplateSelected: boolean = false;
  @ViewChild('approveTemplate') approveTemplate: MatSelect;
  public isAllApproveTemplateSelected: boolean = false;
  @ViewChild('closureReviewTemplate') closureReviewTemplate: MatSelect;
  public isAllClosureReviewTemplateSelected: boolean = false;
  @ViewChild('closureApproveTemplate') closureApproveTemplate: MatSelect;
  public isAllClosureApproveTemplateSelected: boolean = false;

  public onReviewTemplateSelect(event: any, user: any): void {
    if (event.isUserInput) {
      setTimeout(() => {
        this.isAllReviewTemplateSelected = this.templateDropdown.length == this.selectedReviewTemplate.length;
      })
    }
  }

  public toggleAllReviewTemplate(): void {
    if (this.isAllReviewTemplateSelected) {
      for (const item of this.reviewTemplate.options) item.select();
    } else {
      for (const item of this.reviewTemplate.options) item.deselect();
      this.selectedReviewTemplate = [];
    }
  }

  public onApproveTemplateSelect(event: any, user: any): void {
    if (event.isUserInput) {
      setTimeout(() => {
        this.isAllApproveTemplateSelected = this.templateDropdown.length == this.selectedApproveTemplate.length;
      })
    }
  }

  public toggleAllApproveTemplate(): void {
    if (this.isAllApproveTemplateSelected) {
      for (const item of this.approveTemplate.options) item.select();
    } else {
      for (const item of this.approveTemplate.options) item.deselect();
      this.selectedApproveTemplate = [];
    }
  }

  public onClosureReviewTemplateSelect(event: any, user: any): void {
    if (event.isUserInput) {
      setTimeout(() => {
        this.isAllClosureReviewTemplateSelected = this.templateDropdown.length == this.selectedClosureReviewTemplate.length;
      })
    }
  }

  public toggleAllClosureReviewTemplate(): void {
    if (this.isAllClosureReviewTemplateSelected) {
      for (const item of this.closureReviewTemplate.options) item.select();
    } else {
      for (const item of this.closureReviewTemplate.options) item.deselect();
      this.selectedClosureReviewTemplate = [];
    }
  }

  public onClosureApproveTemplateSelect(event: any, user: any): void {
    if (event.isUserInput) {
      setTimeout(() => {
        this.isAllClosureApproveTemplateSelected = this.templateDropdown.length == this.selectedClosureApproveTemplate.length;
      })
    }
  }

  public toggleAllClosureApproveTemplate(): void {
    if (this.isAllClosureApproveTemplateSelected) {
      for (const item of this.closureApproveTemplate.options) item.select();
    } else {
      for (const item of this.closureApproveTemplate.options) item.deselect();
      this.selectedClosureApproveTemplate = [];
    }
  }

  public onEnableCheckListChange(): void {
    [
      this.qmsGroupDetailsFieldData.isCheckListSkippable,
      this.isAllReviewTemplateSelected,
      this.isAllApproveTemplateSelected,
      this.isAllClosureReviewTemplateSelected,
      this.isAllClosureApproveTemplateSelected
    ] = new Array().fill(false);
    [
      this.selectedReviewTemplate,
      this.selectedApproveTemplate,
      this.selectedClosureReviewTemplate,
      this.selectedClosureApproveTemplate
    ] = [[], [], [], []];
  }

  snackbarRef: any;
  showSnackBar(message: string, type: string) {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  moduleDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
    itemsShowLimit: 5,
  };

  multipleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
    //singleSelection: false,
    itemsShowLimit: 3,
  };
  modulevalueexp: any;

  validateNumberFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  selectBoxeForModuleValue() {
    this.moduleValueDropdown = this.dropDownDataForModule.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }));
  }

  selectBoxeForGroupModuleValue() {
    this.grpupmoduleValueDropdown = this.qmsGroupsModuleValue.map((item: any) => ({
      valueExp: item.valueExp,
      displayExp: item.displayExp
    }));
  }

  selectBoxeFordocTypeStageValue() {
    this.docTypeValueDropdown = this.docTypeStageList.map((item: any) => ({
      valueExp: item.codelistName,
      displayExp: item.codelistName
    }));
  }

  selectBoxeForMasterpageDashboardValue() {
    this.masterPageDashboardDropdown = this.masterPageDashboardVal.map((item: any) => ({
      valueExp: item.codelistName,
      displayExp: item.codelistName
    }));
  }

  selectBoxeForskipStageValue() {
    this.skipstageValueDropdown = this.skipStageList.map((item: any) => ({
      valueExp: item.stageName,
      displayExp: item.stageName
    }));
  }

  selectBoxeForfinalStageValue() {
    this.finalstageValueDropdown = this.finalStageList.map((item: any) => ({
      valueExp: item.stageName,
      displayExp: item.stageName
    }));
  }

  private selectBoxForTemplate(): void {
    this.templateDropdown = this.templateList?.filter((x: any) => x.isActive == 'Y')?.map((template: any) => ({
      valueExp: template.templateId,
      displayExp: template.templateName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  onDocTypeRemoved(item: any) { };
  onAddNotidficationSelect(item: any) {

  };
  onAddNotidficationRemoved(item: any) { };
  isProcessing: boolean = false;
  PageName: any;
  dropDownDataForModule: any = [];
  moduleValueDropdown: any;
  grpupmoduleValueDropdown: any = [];
  selectedmoduleValue: any = null;
  selectedmasterpageDashboard: any = null;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  searchValue: any;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  pager: any = {};
  pagedItems: any[];
  error = '';
  makeStickyColumns: any;
  array: any = [];
  visibleAddButton: boolean;
  visibleEditButton: boolean;
  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;
  popupTitle: any;


  calculateTotalPages: number;
  documentTypeCall: any = [];
  designationCodeValue: any;
  departmentCodeValue: any;
  statusCodeValue: any;
  columnLists: any = {};
  dataTypeList: any = [];

  dropDownForModules: any;

  qmsGroupsDetailsList: any = [];
  qmsGroupsUsersList: any = [];
  selectDocTypeName: any;
  selectfinalGenStage: any;
  selectaddNotificationStage: any;
  docTypeValueDropdown: any;
  masterPageDashboardDropdown: any;
  docTypeStageList: any;
  masterPageDashboardVal: any;
  skipstageValueDropdown: any = [];
  finalstageValueDropdown: any = [];
  skipStageList: any = [];
  finalStageList: any = [];
  copyGroupObj: any = [];

  oddModuleValue: any = null;
  oddmasterpageDashboardValue: any = null;
  oddfinalGenStage: any = null;
  oddTypeValue: any = null;
  oddQmsUsers: any = null;

  //visibleDmsGroupUsersAddAndEditPopup:any;

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.documentTypeCall.length, page, this.perPage, targetpage);
    this.pagedItems = this.documentTypeCall.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  dataGridParentCheckBoxChecked(e: any) {
    const isChecked = e.target.checked;
    this.childCheckBoxs = isChecked;

    for (const item of this.documentTypeCall) {
      item.childCheckBoxs = isChecked;
    }
  }

  qmsGroupDetailsPriviousSelectedValue: any;
  qmsGroupDetailsGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.qmsGroupDetailsPriviousSelectedValue != undefined) {
        this.documentTypeCall[this.qmsGroupDetailsPriviousSelectedValue].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
      this.auditTrail.refNo = list.GROUP_DETAIL_ID;
    } else {
      list.childCheckBoxs = false;
    }
    this.visibleAuditTrail = this.documentTypeCall.some((list: any) => list.childCheckBoxs);
    this.qmsGroupDetailsPriviousSelectedValue = idx;
  }

  qmsGroupUsersPriviousSelectedValue: any;
  qmsGroupUsersGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.qmsGroupUsersPriviousSelectedValue != undefined) {
        this.qmsGroupsUsersList[this.qmsGroupUsersPriviousSelectedValue].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
    } else {
      list.childCheckBoxs = false;
    }
    this.qmsGroupUsersPriviousSelectedValue = idx;
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }

      index1++;
    })


    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          column.style.background = 'white';
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }

    })

  }

  onClick(event: any) {

  }

  getcallMethod() {
    this.isProcessing = true;
    this.designationCodeValue = null;
    this.departmentCodeValue = null;
    this.statusCodeValue = null;
    this.documentTypeCall = [];
    const data = {

      gridName: "QMS_GROUP_DETAIL"
    }

    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause ??= "";

        this.makeStickyColumns = response.fixedFieldCnt;

        const data1: any = {

          gridName: "QMS_GROUP_DETAILS_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          status: this.statusCodeValue,
          codelistGroup: null,
          groupId: "" + this.message.masterDetails[0].GROUP_ID,
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        }

        this.reportObj = { ...data1, ...data };
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.documentTypeCall = response1;
            this.visibleAuditTrail = false;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            let rendereddata: any;

            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const size of (data1.fieldSizeListArray as any[])) {
              this.columnLists.fieldSizeListArray.push(size + 'px');
            }

            for (const invisibleCol of this.columnLists.invisibleColumnarray) {
              const index = this.columnLists.columnsListarray.indexOf(invisibleCol);

              if (index !== -1) {
                this.columnLists.columnsListarray.splice(index, 1);
                this.columnLists.fieldColumnarray.splice(index, 1);
                this.columnLists.fieldSizeListArray.splice(index, 1);
              }
            }

            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const dataType of this.dataTypeList) {
                  if (dataType.columnName == this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = dataType.fieldType;
                  }
                }
              }
              for (const docType of this.documentTypeCall) {
                for (const dataType of this.dataTypeList) {
                  if (dataType.fieldType == 'CHECKBOX') {
                    docType[dataType.columnName] = docType[dataType.columnName] === "Y";
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.setPage(1, 0);
              this.pager.totalPages = undefined;
            });
            this.message.gridList = this.documentTypeCall;
            this.collectionSize = this.documentTypeCall.length;

            this.dynamicLabelCall();
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  qmsGroupsModuleValue: any = [];
  callQmsGroupsGetCall() {
    this.qmsGroupsModuleValue = [];
    this.selectedQmsGroupsModuleValue = [];
    this.appService.getQmsGroupByGroupId(this.message.masterDetails[0].GROUP_ID).subscribe((response: any) => {
      this.getQmsGroupsVwDetailsData = response;
      this.qmsGroupsFieldData.groupCode = response.groupCode;
      this.qmsGroupsFieldData.groupName = response.groupName;
      this.qmsGroupsFieldData.groupDescription = response.groupDescription;
      this.qmsGroupsFieldData.isActive = response.isActive == 'Y';
      this.qmsGroupsFieldData.updateReason = response.updateReason;
      if (response.modules) {
        const splittedModules = this.selectedQmsGroupsModuleValue = response.modules.split(",");
        setTimeout(() => { this.isAllModulesSelected = this.qmsGroupsModuleValueDropdown.length == this.selectedQmsGroupsModuleValue.length; })
        this.selectBoxForQmsGroupsModuleValue();

        const matchingModules = this.dropDownDataForModule?.filter((modules: any) => splittedModules.includes(modules.codelistCode))
        this.qmsGroupsModuleValue = matchingModules.map((item: any) => ({
          valueExp: item.codelistCode,
          displayExp: item.codelistName
        }));
        this.selectedmoduleValue = matchingModules.map((item: any) => item.codelistCode).join(',');
        this.selectBoxeForGroupModuleValue();

        this.appService.getoneQmsskipstageOptionsVw(response.modules).subscribe((response: any) => {
          this.skipStageList = response
          this.selectBoxeForskipStageValue();
        });
        this.appService.getoneQmsFinalNoGenerationStageOptionsVw(response.modules).subscribe((response: any) => {
          this.finalStageList = response
          this.selectBoxeForfinalStageValue();
        });
      } else {
        this.selectedQmsGroupsModuleValue = [];
        setTimeout(() => { this.isAllModulesSelected = this.qmsGroupsModuleValueDropdown.length == this.selectedQmsGroupsModuleValue.length; })
      }

      this.qmsGroupsFieldData.updateReason = null;
      this.isProcessing = false;
    })
  }

  qmsGroupsList: any = [];
  nonorgModulesData: any;
  listOfDmsRoles: any = [];
  getQmsGroupsVwDetailsData: any;
  gridTitle: any;
  qmsGroups: any = [];
  copyGroupValueDropdown: any = [];
  activityHandler: any = null;
  activityHandlerOptions: any[] = [];

  ngOnInit(): void {
    this.isProcessing = true;
    // Static dropdown options

    this.activityHandlerOptions = [
      { valueExp: 'Evaluator', displayExp: 'Evaluator' },
      { valueExp: 'Investigator', displayExp: 'Investigator' }
    ];
    this.groupData();
    this.dropDownDataForModule = JSON.parse(sessionStorage.getItem('dropDownForModules') || '{}');
    this.selectBoxeForModuleValue();
    this.getcallMethod();
    this.callQmsGroupsGetCall();
    this.selectBoxForDepartment();
    this.selectBoxForDesignation();
    this.dropDownForDesignation = JSON.parse(sessionStorage.getItem('dropDownForDesignationCode') ?? '{}');
    this.dropDownForDepartment = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') ?? '{}');

    this.appService.getQmsGroupDetailsByGroupId(this.message.masterDetails[0].GROUP_ID).subscribe((response: any) => {
      for (const item of response) {
        item.reopenAllowed = item.reopenAllowed === "Y";
        item.reopenActionsAllowed = item.reopenActionsAllowed === "Y";
        item.effectivenessCheckEnabled = item.effectivenessCheckEnabled === "Y";
        item.isEffectiveDateReqd = item.isEffectiveDateReqd === "Y";
        item.preliminaryActionEnabled = item.preliminaryActionEnabled === "Y";
        item.editableByQA = item.editableByQA === "Y";
        item.editableByDepartmentHead = item.editableByDepartmentHead === "Y";
        item.editableByInvestigator = item.editableByInvestigator === "Y";
        item.editableByApprovers = item.editableByApprovers === "Y";
        item.editableByReviewers = item.editableByReviewers === "Y";
        item.additionalNotificationReqd = item.additionalNotificationReqd === "Y";
      }
      this.qmsGroupsDetailsList = response;
      this.gridTitle = "Update Quality Group";
      this.isProcessing = false;
    });
    let data = {
      status: "active"
    };
    this.appService.getOneQmsUsersVwDetails(data).subscribe((response: any) => {
      this.qmsUsersList = response;
      this.selectBoxForDepartment();
      this.selectBoxForDesignation();
    })
    this.appService.getNonOrgCodeListsByGroupName("DOCUMENT_TYPE_STAGES").subscribe((response: any) => {
      this.docTypeStageList = response
      this.selectBoxeFordocTypeStageValue();
    });
    this.appService.getCodeListsByGroupOrg("MASTERPAGE_DASHBOARD").subscribe((response: any) => {
      this.masterPageDashboardVal = response

      this.selectBoxeForMasterpageDashboardValue();
    });
  };

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();

    if (filter === '') {
      this.pagedItems = this.documentTypeCall.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.documentTypeCall.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)

      );
    }
  }

  qmsGroupsFieldData: any = {};
  qmsGroupDetailsFieldData: any = {};
  qmsGroupUsersFieldData: any = {};
  qmsGroupDetails: any = [];
  copyGroupDetailValueDropdown: any = [];
  @ViewChild('qmsGroupDetailsAddAndEditPopup', { static: true }) qmsGroupDetailsAddAndEditPopup: TemplateRef<any>;
  @ViewChild('activeAndInActivePopup', { static: true }) activeAndInActivePopup: TemplateRef<any>;
  @ViewChild('qmsGroupUsersAddAndEditPopup', { static: true }) qmsGroupUsersAddAndEditPopup: TemplateRef<any>;
  @ViewChild('qmsGroupUsersDeletePopup', { static: true }) qmsGroupUsersDeletePopup: TemplateRef<any>;
  @ViewChild('qmsGroupUsersPopup', { static: true }) qmsGroupUsersPopup: TemplateRef<any>;
  @ViewChild('qmsGroupActiveInactivePopup', { static: true }) qmsGroupActiveInactivePopup: TemplateRef<any>;
  @ViewChild('qmsGroupUserActiveInactivePopup', { static: true }) qmsGroupUserActiveInactivePopup: TemplateRef<any>;

  @ViewChild('qmsGroupDetailsCopyPopup', { static: true }) qmsGroupDetailsCopyPopup: TemplateRef<any>;
  visibleqmsGroupDetailsCopyPopup: MatDialogRef<TemplateRef<any>>;

  @ViewChild('flexifieldsPopup', { static: true }) flexifieldsPopup: TemplateRef<any>;
  visibleFlexifieldsPopup: MatDialogRef<TemplateRef<any>>;

  @ViewChild('qmsGroupDetailTypeSettingsPopup', { static: true }) qmsGroupDetailTypeSettingsPopup: TemplateRef<any>;
  @ViewChild('qmsGroupDetailTypeSettingsAddAndEditPopup', { static: true }) qmsGroupDetailTypeSettingsAddAndEditPopup: TemplateRef<any>;
  @ViewChild('qmsGroupDetailTypeSettingsDeletePopup', { static: true }) qmsGroupDetailTypeSettingsDeletePopup: TemplateRef<any>;


  visibleqmsGroupDetailsAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleActiveAndInActivePopup: MatDialogRef<TemplateRef<any>>;
  visibleQmsGroupUsersAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleQmsGroupUsersDeletePopup: MatDialogRef<TemplateRef<any>>;
  visibleQmsGroupUserPopup: MatDialogRef<TemplateRef<any>>;
  visibleQmsGroupActiveInactivePopup: MatDialogRef<TemplateRef<any>>;
  visibleQmsGroupUserActiveInactivePopup: MatDialogRef<TemplateRef<any>>;

  visibleQmsGroupDetailTypeSettingsPopup: MatDialogRef<TemplateRef<any>>;
  visibleqmsGroupDetailTypeSettingsAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleQmsGroupDetailTypeSettingsDeletePopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '15px' },
  };

  flexifieldsPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '15px' },
  };
  CopyPopupConfig = {
    width: '30%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };
  qmsGroupUsersDeletePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  activeAndInActivePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  qmsGroupUsersPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  qmsGroupActiveInactivePopupConfig = {
    width: '35%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  qmsGroupUserActiveInactivePopupConfig = {
    width: '35%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  /* Start Quality Groups */

  selectedQmsGroupsModuleValue: any = [];
  selectedQmsGroupsModuleValueExp: any = [];
  selectedQmsGroupsModuleDisplayExp: any = [];
  qmsGroupsModuleValueDropdown: any = [];
  selectedCopyGroupValue: any = null;
  selectedCopyGroupDetailValue: any = null;
  selectedCopyGroupDetailName: string = '';
  selectBoxForQmsGroupsModuleValue() {
    this.qmsGroupsModuleValueDropdown = [];

    for (const module of this.dropDownDataForModule) {
      if (module.codelistCode !== 'TRN' && module.codelistCode !== 'DOCS' && module.codelistCode !== 'BP') {
        this.qmsGroupsModuleValueDropdown.push({
          valueExp: module.codelistCode,
          displayExp: module.codelistName
        });
      }
    }
  }

  isForAuditCategory: any = false;

  groupData() {
    this.appService.getQmsGroups().subscribe((response: any) => {
      this.qmsGroups = response
      this.selectButtonCopyGroups();
    });
  }
  selectButtonCopyGroups() {
    this.copyGroupValueDropdown = [];

    for (const group of this.qmsGroups) {
      this.copyGroupValueDropdown.push({
        valueExp: group.groupId,
        displayExp: group.groupName
      });
    }
  }
  onCopyGroupSelectOld(item: any) {
    this.isProcessing = true;

    if (item.valueExp != null) {
      this.appService.getQmsGroupDetailsByGroupId(item.valueExp).subscribe((response: any) => {
        this.qmsGroupDetails = response;
        this.isProcessing = false;
        this.selectButtonCopyGroupDetails();
      });
    }
  }
  activityHandlerSearchText: any;

  copyGroupsearchTxt: any;
  onCopyGroupSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (item) {
          this.isProcessing = true;
          this.appService.getQmsGroupDetailsByGroupId(item.valueExp).subscribe((response: any) => {
            this.qmsGroupDetails = response;
            this.isProcessing = false;
            this.selectButtonCopyGroupDetails();
          });
        }
        this.selectedCopyGroupValue = item.valueExp;
      }
    }
  }

  copyGroupDetailssearchTxt: any;
  onCopyGroupDetailsSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectedCopyGroupDetailValue = item.valueExp;
        this.selectedCopyGroupDetailName = item.displayExp;
      }
    }
  }
  selectButtonCopyGroupDetails() {
    this.copyGroupDetailValueDropdown = [];

    for (const detail of this.qmsGroupDetails) {
      this.copyGroupDetailValueDropdown.push({
        valueExp: detail.groupDetailId,
        displayExp: detail.module
      });
    }
  }

  onCopyGroupDeSelectAll(item: any) {

  };
  groupCodeReqValue: any;
  groupNameReqValue: any;
  updateReason: any;
  groupCodeValueRequiredMsg: any;
  groupNameValueRequiredMsg: any;
  moduleValueRequiredMsg: any;
  activityHandlerMsg: any;
  finalNoGenerationStageRequiredMsg: any;
  updateReasonRequiredMsg: any;
  updateReason2: any;
  updateReason3: any;
  updateReasonRequiredMsg2: any;
  updateReasonRequiredMsg3: any;
  qmsGroupsFieldValidation() {
    this.updateReason = document.getElementById('updateReason1') as HTMLInputElement;
    this.updateReasonRequiredMsg = document.getElementById('updateReason-required-msg1') as HTMLInputElement;

    if (this.qmsGroupsFieldData.updateReason != '' && this.qmsGroupsFieldData.updateReason != undefined) {
      this.updateReason.style.border = 'none';
      this.updateReasonRequiredMsg.style.display = 'none';
    } else {
      this.updateReason.style.border = '1px solid red';
      this.updateReasonRequiredMsg.style.display = 'block';
    }
  }

  onQmsGroupFocusout() {
    this.groupCodeReqValue = document.getElementById('groupCodeValue') as HTMLInputElement;
    this.groupNameReqValue = document.getElementById('groupNameValue') as HTMLInputElement;
    this.updateReason = document.getElementById('updateReason1') as HTMLInputElement;

    this.groupCodeValueRequiredMsg = document.getElementById('groupCode-required-msg') as HTMLInputElement;
    this.groupNameValueRequiredMsg = document.getElementById('groupName-required-msg') as HTMLInputElement;
    this.updateReasonRequiredMsg = document.getElementById('updateReason-required-msg1') as HTMLInputElement;

    if (this.groupCodeReqValue.value != '' && this.groupCodeReqValue.value != null && this.groupCodeReqValue.value != undefined) {
      this.groupCodeReqValue.style.border = 'none';
      this.groupCodeValueRequiredMsg.style.display = 'none';
    } else {
      this.groupCodeReqValue.style.border = '1px solid red';
      this.groupCodeValueRequiredMsg.style.display = 'block';
    }

    if (this.groupNameReqValue.value != '' && this.groupNameReqValue.value != null && this.groupNameReqValue.value != undefined) {
      this.groupNameReqValue.style.border = 'none';
      this.groupNameValueRequiredMsg.style.display = 'none';
    } else {
      this.groupNameReqValue.style.border = '1px solid red';
      this.groupNameValueRequiredMsg.style.display = 'block';
    }

    if (this.updateReason.value != '' && this.updateReason.value != null && this.updateReason.value != undefined) {
      this.updateReason.style.border = 'none';
      this.updateReasonRequiredMsg.style.display = 'none';
    } else {
      this.updateReason.style.border = '1px solid red';
      this.updateReasonRequiredMsg.style.display = 'block';
    }
  }

  onQmsGroupDetailsFocusout() {
    this.updateReason = document.getElementById('updateReason2') as HTMLInputElement;
    this.updateReasonRequiredMsg = document.getElementById('updateReason-required-msg2') as HTMLInputElement;

    if (this.updateReason.value != '' && this.updateReason.value != null && this.updateReason.value != undefined) {
      this.updateReason.style.border = 'none';
      this.updateReasonRequiredMsg.style.display = 'none';
    } else {
      this.updateReason.style.border = '1px solid red';
      this.updateReasonRequiredMsg.style.display = 'block';
    }
  }

  onActiveAndInActiveFocusout() {
    this.deleteFiledValue = document.getElementById('deleteTextarea1') as HTMLInputElement;
    this.deleteFiledValueRequiredMsg = document.getElementById('deleteTextarea-required-msg1') as HTMLInputElement;

    if (this.deleteFiledValue.value != undefined && this.deleteFiledValue.value != '' && this.deleteFiledValue.value != null) {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    } else {
      this.deleteFiledValue.style.border = '1px solid red';
      this.deleteFiledValueRequiredMsg.style.display = 'block';
    }
  }

  onQmsGroupActiveAndInActiveFocusout() {
    this.deleteFiledValue = document.getElementById('groupActiveInactiveReason') as HTMLInputElement;
    this.deleteFiledValueRequiredMsg = document.getElementById('groupActiveInactiveReason-required-msg') as HTMLInputElement;

    if (this.deleteFiledValue.value != undefined && this.deleteFiledValue.value != '' && this.deleteFiledValue.value != null) {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    } else {
      this.deleteFiledValue.style.border = '1px solid red';
      this.deleteFiledValueRequiredMsg.style.display = 'block';
    }
  }

  onQmsGroupUserActiveAndInActiveFocusout() {
    this.deleteFiledValue = document.getElementById('groupUserActiveInactiveReason') as HTMLInputElement;
    this.deleteFiledValueRequiredMsg = document.getElementById('groupUserActiveInactiveReason-required-msg') as HTMLInputElement;

    if (this.deleteFiledValue.value != undefined && this.deleteFiledValue.value != '' && this.deleteFiledValue.value != null) {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    } else {
      this.deleteFiledValue.style.border = '1px solid red';
      this.deleteFiledValueRequiredMsg.style.display = 'block';
    }
  }

  onQmsGroupUsersFocusout() {
    this.deleteFiledValue = document.getElementById('deleteTextarea2') as HTMLInputElement;
    this.deleteFiledValueRequiredMsg = document.getElementById('deleteTextarea-required-msg2') as HTMLInputElement;

    if (this.deleteFiledValue.value != undefined && this.deleteFiledValue.value != '' && this.deleteFiledValue.value != null) {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    } else {
      this.deleteFiledValue.style.border = '1px solid red';
      this.deleteFiledValueRequiredMsg.style.display = 'block';
    }
  }

  editQmsGroupsFunction(x: any) {
    this.appService.getQmsGroupDetailsByGroupId(this.message.masterDetails[0].GROUP_ID)
      .subscribe((response: any) => {

        const allPresent = response.every((r: any) => this.selectedQmsGroupsModuleValue.includes(r.module));

        if (allPresent) {
          this.execute(x);
        } else {
          this.showSnackBar(
            'Module(s) configured in the grid below are not selected in the Module dropdown.\nPlease select the module(s) or remove the corresponding configuration.', 'E');
        }
      });
  }


  isActiveValue: any;
  pushedQmsGroupsModuleValue: any = [];
  execute(qmsGroupsFieldData: any) {
    this.isProcessing = true;
    this.isActiveValue = qmsGroupsFieldData.isActive ? 'Y' : 'N';
    if (this.selectedQmsGroupsModuleValue.length == 0) {
      this.moduleValueRequiredMsg = document.getElementById('module-required-msg1') as HTMLInputElement;
      this.moduleValueRequiredMsg.style.display = 'block';
      this.isProcessing = false;
    } else if (this.qmsGroupsFieldData.updateReason == '' || this.qmsGroupsFieldData.updateReason == undefined) {
      this.qmsGroupsFieldValidation();
      this.isProcessing = false;
    } else {
      delete qmsGroupsFieldData.createdOn;
      delete qmsGroupsFieldData.updatedOn;

      this.qmsGroupsFieldData.modules = "";
      if (this.selectedQmsGroupsModuleValue.length > 0) {
        this.qmsGroupsFieldData.modules = this.selectedQmsGroupsModuleValue.join(',');
      }
      let updateQmsGroupsData = {
        groupId: this.message.masterDetails[0].GROUP_ID,
        groupCode: this.qmsGroupsFieldData.groupCode,
        groupName: this.qmsGroupsFieldData.groupName,
        modules: this.qmsGroupsFieldData.modules,
        groupDescription: this.qmsGroupsFieldData.groupDescription,
        isActive: this.isActiveValue,
        updateReason: this.qmsGroupsFieldData.updateReason,
      }
      this.appService.updateQualityGroup(updateQmsGroupsData).subscribe({
        next: (Response: any) => {
          if (Response.resultType == 'S') {
            this.ngOnInit();
            this.isProcessing = false;
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok",
              pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
  }

  /* End Quality Groups */
  copyQmsGroupDetailsAddPopup() {
    this.selectedCopyGroupValue = null;
    this.selectedCopyGroupDetailValue = null;
    this.selectedCopyGroupDetailName = '';
    this.popupTitle = "Copy Quality Group Detail";
    this.copyGroupObj = {
      fromGroupId: null,
      fromGroupDetailId: null,
      toGroupId: this.message.masterDetails[0].GROUP_ID,
    };
    this.visibleqmsGroupDetailsCopyPopup = this.dialog.open(this.qmsGroupDetailsCopyPopup, this.CopyPopupConfig);
  }
  copyFunction() {


    if (this.selectedCopyGroupValue) {
      this.copyGroupObj.fromGroupId = this.selectedCopyGroupValue;
    } else {
      this.copyGroupObj.fromGroupId = null;
    }
    if (this.selectedCopyGroupDetailValue) {
      this.copyGroupObj.fromGroupDetailId = this.selectedCopyGroupDetailValue;
    } else {
      this.copyGroupObj.fromGroupDetailId = null;
    }
    console.log(this.copyGroupObj);
    this.appService.copyQmsGroupDetails(this.copyGroupObj).subscribe({
      next: (Response: any) => {
        if (Response.resultType == 'S') {
          this.visibleqmsGroupDetailsCopyPopup.close();
          this.copyGroupObj.GROUP_DETAIL_ID = Response.OP_TO_GROUP_DETAIL_ID;
          this.copyGroupObj.GROUP_ID = this.copyGroupObj.toGroupId;
          this.copyGroupObj.MODULE = this.selectedCopyGroupDetailName;
          this.getcallMethod();
          this.openQmsGroupDetailsEditPopup(this.copyGroupObj);
        }
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: Response.result,
            type: Response.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok",
            pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }
  cancelCopyFunction() {
    this.visibleqmsGroupDetailsCopyPopup.close();
  }
  openQmsGroupDetailsAddPopup() {
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.isForAuditCategory = false;
    this.popupTitle = "Create Quality Group Details";
    this.qmsGroupDetailsFieldData = {

      groupId: this.message.masterDetails[0].GROUP_ID,
      groupDetailId: null,
      module: null,
      skipStages: null,
      finalNoGenerationStage: null,
      reopenAllowed: false,
      reopenActionsAllowed: false,
      effectivenessCheckEnabled: false,
      editableByQA: false,
      preliminaryActionEnabled: false,
      isEffectiveDateReqd: false,
      editableByApprovers: false,
      editableByReviewers: false,
      enableCheckList: false,
      expectedClosureInDays: null,
      duesInDays: null,
      additionalNotificationReqd: false,
      additionalNotificationEmails: null,
      additionalNotificationStages: null,
      deleteReason: null,
      updateReason: null,
      isRiskCalculationReqd: false,
      isExtensionRequired: false,
      isGroupOwnerRequired: false,
      masterpageDashboard: null,
      riskFormula: "",
      activityClosureDays: null,
      activityHandler: null

    };
    this.selectedmoduleValue = null;
    this.selectDocTypeName = [];
    this.selectfinalGenStage = null;
    this.selectaddNotificationStage = [];
    this.selectedUsersArray = [];
    this.modulevalueexp = null;
    this.visibleqmsGroupDetailsAddAndEditPopup = this.dialog.open(this.qmsGroupDetailsAddAndEditPopup, this.addAndEditPopupConfig);
  }

  refreshQmsGroupDetailsGridData() {
    this.getcallMethod();
  }

  backToPreviousPage() {
    this.router.navigate(['dashboard/qmsGroups']);
  }

  filteredModuleValue: any;
  previousGroupId: any;
  previousGroupDetailId: any;

  private checkSkipStageSelection(): void {
    this.isSkipstageSelected = this.skipstageValueDropdown.length === this.selectDocTypeName.length;
  }
  private updateNotificationSelectionState(): void {
    this.isAllNotificationSelected = this.activityStatusDropdown.length === this.selectedNotificationStatuses.length;
  }
  openQmsGroupDetailsEditPopup(data: any) {
    this.selectedmoduleValue = data.MODULE;
    // Load statuses from sessionStorage
    this.getActivityStatusList();
    this.getCheckListTemplate(data.MODULE);
    // Reset selections
    this.selectedNotificationStatuses = [];
    this.qmsGroupDetailsFieldData.additionalNotificationStages = '';
    this.isProcessing = true;

    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.qmsGroupDetailsFieldData.updateReason = "";
    this.selectDocTypeName = [];
    this.selectfinalGenStage = null;
    this.selectaddNotificationStage = [];
    this.popupTitle = "Update " + data.MODULE + " Group Details";
    this.previousGroupId = data.GROUP_ID;
    this.previousGroupDetailId = data.GROUP_DETAIL_ID;

    this.appService.getQmsGroupDetailsByGroupDetailId(this.message.masterDetails[0].GROUP_ID, data.GROUP_DETAIL_ID).subscribe((response: any) => {

      this.appService.getoneQmsskipstageOptionsVw(response.module).subscribe((response1: any) => {
        this.skipStageList = response1
        this.selectBoxeForskipStageValue();

        this.appService.getoneQmsFinalNoGenerationStageOptionsVw(response.module).subscribe((response2: any) => {
          this.finalStageList = response2
          this.selectBoxeForfinalStageValue();

          if (response.activityHandler) {
            this.activityHandler = response.activityHandler
          }

          if (!response.module) {
            return;
          }

          this.oddModuleValue = null;
          this.selectBoxeForGroupModuleValue();

          let matchingModules = null;
          if (this.qmsGroupsModuleValue) {
            for (const mod of this.qmsGroupsModuleValue) {
              if (mod.valueExp === response.module) {
                matchingModules = mod;
                break;
              }
            }
          }

          if (!matchingModules) {
            this.oddModuleValue = response.module;
            this.grpupmoduleValueDropdown.push({
              valueExp: response.module,
              displayExp: response.module
            });
          }

          this.modulevalueexp = response.module;
          this.selectedmoduleValue = response.module;
          this.isForAuditCategory = response.module === 'Audit';
          this.selectDocTypeName = response.skipStages ? response.skipStages.split(",") : [];
          setTimeout(this.checkSkipStageSelection.bind(this))

          if (response.finalNoGenerationStage) {
            this.selectBoxeForfinalStageValue();
            let matchingFinalNoGenerationStage = null;

            if (this.finalStageList) {
              for (const stage of this.finalStageList) {
                if (stage.stageName === response.finalNoGenerationStage) {
                  matchingFinalNoGenerationStage = stage;
                  break;
                }
              }
            }
            if (!matchingFinalNoGenerationStage) {
              this.oddfinalGenStage = response.finalNoGenerationStage;
              this.finalstageValueDropdown.push({
                valueExp: response.finalNoGenerationStage,
                displayExp: response.finalNoGenerationStage
              })
            }
            this.selectfinalGenStage = response.finalNoGenerationStage;
          }

          if (response.additionalNotificationReqd) {
            this.selectedNotificationStatuses = response.additionalNotificationStages?.split(',') ?? [];
          }
          setTimeout(this.updateNotificationSelectionState.bind(this));

          this.selectedUsersArray = [];

          if (response.additionalNotificationEmails && this.qmsUsersList) {
            const userIds = response.additionalNotificationEmails.split(',');

            for (const id of userIds) {

              let matchedUser = null;
              for (const user of this.qmsUsersList) {
                if (user.userId == id) {
                  matchedUser = user;
                  break;
                }
              }

              if (matchedUser) {
                this.selectedUsersArray.push({
                  userId: matchedUser.userId,
                  userName: matchedUser.userName
                });
              }
            }

            console.log("Valid Users:", this.selectedUsersArray);
          }

          this.qmsGroupDetailsFieldData.additionalNotificationReqd = response.additionalNotificationReqd == "Y";
          this.qmsGroupDetailsFieldData.editableByApprovers = response.editableByApprovers == "Y";
          this.qmsGroupDetailsFieldData.editableByReviewers = response.editableByReviewers == "Y";
          this.qmsGroupDetailsFieldData.effectivenessCheckEnabled = response.effectivenessCheckEnabled == "Y";
          this.qmsGroupDetailsFieldData.preliminaryActionEnabled = response.preliminaryActionEnabled == "Y";
          this.qmsGroupDetailsFieldData.isEffectiveDateReqd = response.isEffectiveDateReqd == "Y";
          this.qmsGroupDetailsFieldData.reopenActionsAllowed = response.reopenActionsAllowed == "Y";
          this.qmsGroupDetailsFieldData.reopenAllowed = response.reopenAllowed == "Y";
          this.qmsGroupDetailsFieldData.isActive = response.isActive == "Y";
          this.qmsGroupDetailsFieldData.isRiskCalculationReqd = response.isRiskCalculationReqd == "Y";
          this.qmsGroupDetailsFieldData.isExtensionRequired = response.isExtensionRequired == "Y";
          this.qmsGroupDetailsFieldData.isGroupOwnerRequired = response.isGroupOwnerRequired == "Y";
          this.qmsGroupDetailsFieldData.editableByQA = response.editableByQA == "Y";
          this.qmsGroupDetailsFieldData.editableByDepartmentHead = response.editableByDepartmentHead == "Y";
          this.qmsGroupDetailsFieldData.editableByInvestigator = response.editableByInvestigator == "Y";
          this.qmsGroupDetailsFieldData.enableCheckList = response.enableCheckList == "Y";
          this.qmsGroupDetailsFieldData.isCheckListSkippable = response.isCheckListSkippable == "Y";
          this.qmsGroupDetailsFieldData.expectedClosureInDays = response.expectedClosureInDays;
          this.qmsGroupDetailsFieldData.duesInDays = response.duesInDays;
          this.qmsGroupDetailsFieldData.actionApprovalReminderDays = response.actionApprovalReminderDays;
          this.qmsGroupDetailsFieldData.repeatActionApprovalReminderEveryDays = response.repeatActionApprovalReminderEveryDays;
          this.qmsGroupDetailsFieldData.reviewReminderDays = response.reviewReminderDays;
          this.qmsGroupDetailsFieldData.repeatReviewReminderEveryDays = response.repeatReviewReminderEveryDays;
          this.qmsGroupDetailsFieldData.approvalReminderDays = response.approvalReminderDays;
          this.qmsGroupDetailsFieldData.repeatApprovalReminderEveryDays = response.repeatApprovalReminderEveryDays;
          this.qmsGroupDetailsFieldData.closureApprovalReminderDays = response.closureApprovalReminderDays;
          this.qmsGroupDetailsFieldData.repeatClosureApprovalReminderEveryDays = response.repeatClosureApprovalReminderEveryDays;
          this.qmsGroupDetailsFieldData.actionReminderDays = response.actionReminderDays;
          this.qmsGroupDetailsFieldData.repeatActionReminderEveryDays = response.repeatActionReminderEveryDays;
          this.qmsGroupDetailsFieldData.actionReviewReminderDays = response.actionReviewReminderDays;
          this.qmsGroupDetailsFieldData.repeatActionReviewReminderEveryDays = response.repeatActionReviewReminderEveryDays;
          this.qmsGroupDetailsFieldData.pendingAcceptanceReminderDays = response.pendingAcceptanceReminderDays;
          this.qmsGroupDetailsFieldData.repeatPendingAcceptanceReminderEveryDays = response.repeatPendingAcceptanceReminderEveryDays;
          this.qmsGroupDetailsFieldData.ecQaApprovalReminderDays = response.ecQaApprovalReminderDays;
          this.qmsGroupDetailsFieldData.repeatEcQaApprovalReminderEveryDays = response.repeatEcQaApprovalReminderEveryDays;
          this.qmsGroupDetailsFieldData.qaApprovalReminderDays = response.qaApprovalReminderDays;
          this.qmsGroupDetailsFieldData.repeatQaApprovalReminderEveryDays = response.repeatQaApprovalReminderEveryDays;
          this.qmsGroupDetailsFieldData.closureReviewReminderDays = response.closureReviewReminderDays;
          this.qmsGroupDetailsFieldData.repeatClosureReviewReminderEveryDays = response.repeatClosureReviewReminderEveryDays;
          this.qmsGroupDetailsFieldData.overallClosureDateReminderDays = response.overallClosureDateReminderDays;
          this.qmsGroupDetailsFieldData.overallClosureDateEscalationReminderEveryDays = response.overallClosureDateEscalationReminderEveryDays;
          this.qmsGroupDetailsFieldData.effectivenessCheckReminderDays = response.effectivenessCheckReminderDays;
          this.qmsGroupDetailsFieldData.effectivenessCheckReminderReminderEveryDays = response.effectivenessCheckReminderReminderEveryDays;
          this.qmsGroupDetailsFieldData.questionnaireCompletionReminderDays = response.questionnaireCompletionReminderDays;
          this.qmsGroupDetailsFieldData.repeatQuestionnaireCompletionReminderEveryDays = response.repeatQuestionnaireCompletionReminderEveryDays;
          this.qmsGroupDetailsFieldData.followupCompletionReminderDays = response.followupCompletionReminderDays;
          this.qmsGroupDetailsFieldData.repeatFollowupCompletionReminderEveryDays = response.repeatFollowupCompletionReminderEveryDays;
          this.qmsGroupDetailsFieldData.findingsCompletionReminderDays = response.findingsCompletionReminderDays;
          this.qmsGroupDetailsFieldData.repeatFindingsCompletionReminderEveryDays = response.repeatFindingsCompletionReminderEveryDays;
          this.qmsGroupDetailsFieldData.auditApproachReminderDays = response.auditApproachReminderDays;
          this.qmsGroupDetailsFieldData.additionalNotificationEmails = response.additionalNotificationEmails;
          this.qmsGroupDetailsFieldData.auditSubGroupList = response.auditSubGroupList;
          this.qmsGroupDetailsFieldData.auditAnnualRefList = response.auditAnnualRefList;
          this.qmsGroupDetailsFieldData.riskFormula = response.riskFormula;
          this.qmsGroupDetailsFieldData.masterpageDashboard = response.masterpageDashboard;
          this.qmsGroupDetailsFieldData.additionalNotificationStages = response.additionalNotificationStages;
          this.selectedmasterpageDashboard = response.masterpageDashboard;
          this.qmsGroupDetailsFieldData.activityClosureDays = response.activityClosureDays
          this.selectedReviewTemplate = response.reviewCheckListTemplateIds ? response.reviewCheckListTemplateIds.split(',').map(Number) : [];
          this.selectedApproveTemplate = response.approveCheckListTemplateIds ? response.approveCheckListTemplateIds.split(',').map(Number) : [];
          this.selectedClosureReviewTemplate = response.closureReviewCheckListTemplateIds ? response.closureReviewCheckListTemplateIds.split(',').map(Number) : [];
          this.selectedClosureApproveTemplate = response.closureApproveCheckListTemplateIds ? response.closureApproveCheckListTemplateIds.split(',').map(Number) : [];

          setTimeout(this.updateTemplateSelections.bind(this));
          this.visibleqmsGroupDetailsAddAndEditPopup = this.dialog.open(this.qmsGroupDetailsAddAndEditPopup, this.addAndEditPopupConfig);
          this.isProcessing = false;
        });
      });
    });
  }

  private updateTemplateSelections(): void {
    setTimeout(() => {
      this.isAllReviewTemplateSelected = this.selectedReviewTemplate.length === this.templateDropdown.length
      this.isAllApproveTemplateSelected = this.selectedApproveTemplate.length === this.templateDropdown.length
      this.isAllClosureReviewTemplateSelected = this.selectedClosureReviewTemplate.length === this.templateDropdown.length
      this.isAllClosureApproveTemplateSelected = this.selectedClosureApproveTemplate.length === this.templateDropdown.lengthOfColumns
    }, 0)
  }

  statusRequiredMsg: any;

  qmsGroupDetailsFieldValidation() {
    this.moduleValueRequiredMsg = document.getElementById('module-required-msg2') as HTMLInputElement;
    this.finalNoGenerationStageRequiredMsg = document.getElementById('finalNoGenerationStage-required-msg') as HTMLInputElement;
    this.activityHandlerMsg = document.getElementById('activity-handler-required-msg') as HTMLInputElement;
    this.statusRequiredMsg = document.getElementById('status-required-msg') as HTMLInputElement;
    if (this.qmsGroupDetailsFieldData.additionalNotificationReqd) {
      if (this.selectedNotificationStatuses.length === 0 &&
        !this.qmsGroupDetailsFieldData.additionalNotificationStages?.trim()) {
        this.statusRequiredMsg.style.display = 'block';
      } else {
        this.statusRequiredMsg.style.display = 'none';
      }
    }

    this.moduleValueRequiredMsg.style.display = this.selectedmoduleValue ? 'none' : 'block';

    this.finalNoGenerationStageRequiredMsg.style.display = this.selectfinalGenStage ? 'none' : 'block';

    if (this.selectedmoduleValue === 'CC' && this.activityHandlerMsg) {
      this.activityHandlerMsg.style.display = this.activityHandler ? 'none' : 'block';
    }
  }

  private isAnyChecklistTemplateSelected(): boolean {
    return (
      this.selectedReviewTemplate.length > 0 ||
      this.selectedApproveTemplate.length > 0 ||
      this.selectedClosureReviewTemplate.length > 0 ||
      this.selectedClosureApproveTemplate.length > 0
    );
  }

  private isAnyTemplateConfigured(): boolean {
    const module = this.selectedmoduleValue;
    const skipStages = this.selectDocTypeName;

    // Define conditions for each template dropdown to be considered (i.e., should be populated)
    const reviewRequired = module && !skipStages.includes('Review');
    const approveRequired = module && module !== 'AU' && !skipStages.includes('Approve');
    const closureReviewRequired = module && !skipStages.includes('Closure Review');
    const closureApproveRequired = module && !skipStages.includes('Closure Approve');

    // Check if the dropdown is relevant AND has *any* configured templates (length > 0)
    const hasReviewTemplates = reviewRequired && this.templateDropdown && this.templateDropdown.length > 0;
    const hasApproveTemplates = approveRequired && this.templateDropdown && this.templateDropdown.length > 0;
    const hasClosureReviewTemplates = closureReviewRequired && this.templateDropdown && this.templateDropdown.length > 0;
    const hasClosureApproveTemplates = closureApproveRequired && this.templateDropdown && this.templateDropdown.length > 0;

    // Return true if any of the potentially relevant dropdowns have configured templates
    return hasReviewTemplates || hasApproveTemplates || hasClosureReviewTemplates || hasClosureApproveTemplates;
  }

  addAndEditQmsGroupDetailsFunction(qmsGroupDetailsFieldData: any) {
    this.isProcessing = true;

    const hasMissingRequiredFields = (
      !this.selectedmoduleValue ||
      !this.selectfinalGenStage ||
      (this.selectedmoduleValue == 'CC' && !this.activityHandler) ||
      (qmsGroupDetailsFieldData.additionalNotificationReqd &&
        (this.selectedNotificationStatuses.length === 0 &&
          !qmsGroupDetailsFieldData.additionalNotificationStages?.trim()))
    );


    let hasNoTemplateSelectionWhenEnabled = false;
    let validationMessage = "";

    if (qmsGroupDetailsFieldData.enableCheckList) {
      const isAnyTemplateConfigured = this.isAnyTemplateConfigured();
      if (!isAnyTemplateConfigured) {
        hasNoTemplateSelectionWhenEnabled = true;
        validationMessage = "Kindly configure templates for this module, If not disable checklist to continue !";
      } else if (!this.isAnyChecklistTemplateSelected()) {
        hasNoTemplateSelectionWhenEnabled = true;
        validationMessage = "At least one checklist template must be selected when 'Enable Checklist' is Yes.";
      }
    }
    if (hasMissingRequiredFields || hasNoTemplateSelectionWhenEnabled) {
      this.qmsGroupDetailsFieldValidation();
      if (hasNoTemplateSelectionWhenEnabled) {
        this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: validationMessage,
            type: 'Error',
            buttonLabel: "Ok",
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: 'Error',
        });
      }
      this.isProcessing = false;
    } else {
      let data = {
        ...qmsGroupDetailsFieldData,
        module: this.selectedmoduleValue ?? null,
        finalNoGenerationStage: this.selectfinalGenStage ?? null,
        skipStages: this.selectDocTypeName.join(','),
        reopenAllowed: qmsGroupDetailsFieldData.reopenAllowed ? "Y" : "N",
        reopenActionsAllowed: qmsGroupDetailsFieldData.reopenActionsAllowed ? "Y" : "N",
        effectivenessCheckEnabled: qmsGroupDetailsFieldData.effectivenessCheckEnabled ? "Y" : "N",
        preliminaryActionEnabled: qmsGroupDetailsFieldData.preliminaryActionEnabled ? "Y" : "N",
        isEffectiveDateReqd: qmsGroupDetailsFieldData.isEffectiveDateReqd ? "Y" : "N",
        editableByQA: qmsGroupDetailsFieldData.editableByQA ? "Y" : "N",
        editableByDepartmentHead: qmsGroupDetailsFieldData.editableByDepartmentHead ? "Y" : "N",
        editableByInvestigator: qmsGroupDetailsFieldData.editableByInvestigator ? "Y" : "N",
        editableByApprovers: qmsGroupDetailsFieldData.editableByApprovers ? "Y" : "N",
        editableByReviewers: qmsGroupDetailsFieldData.editableByReviewers ? "Y" : "N",
        additionalNotificationReqd: qmsGroupDetailsFieldData.additionalNotificationReqd ? "Y" : "N",
        isRiskCalculationReqd: qmsGroupDetailsFieldData.isRiskCalculationReqd ? "Y" : "N",
        isExtensionRequired: qmsGroupDetailsFieldData.isExtensionRequired ? "Y" : "N",
        isGroupOwnerRequired: qmsGroupDetailsFieldData.isGroupOwnerRequired ? "Y" : "N",
        enableCheckList: qmsGroupDetailsFieldData.enableCheckList ? "Y" : "N",
        isCheckListSkippable: qmsGroupDetailsFieldData.isCheckListSkippable ? "Y" : "N",
        masterpageDashboard: this.selectedmasterpageDashboard,
        additionalNotificationEmails: this.selectedUsersArray?.map((user: any) => user.userId).join(","),
        additionalNotificationStages: this.selectedNotificationStatuses.join(','),
        ...this.selectedmoduleValue == 'CC' && { activityHandler: this.activityHandler },
        reviewCheckListTemplateIds: this.selectedReviewTemplate.length ? this.selectedReviewTemplate?.join(',') : null,
        approveCheckListTemplateIds: this.selectedApproveTemplate.length ? this.selectedApproveTemplate?.join(',') : null,
        closureReviewCheckListTemplateIds: this.selectedClosureReviewTemplate.length ? this.selectedClosureReviewTemplate?.join(',') : null,
        closureApproveCheckListTemplateIds: this.selectedClosureApproveTemplate.length ? this.selectedClosureApproveTemplate?.join(',') : null,
      }
      if (!this.visibleEditButton) {
        this.appService.createQmsGroupDetail(data).subscribe({
          next: (Response: any) => {
            if (Response.resultType == 'S') {
              this.visibleqmsGroupDetailsAddAndEditPopup.close();
              this.ngOnInit();
            }
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: Response.result,
                type: Response.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok",
                pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      }
      else if (this.qmsGroupDetailsFieldData.updateReason) {
        const modifiedData = {
          ...data,
          groupId: this.previousGroupId,
          groupDetailId: this.previousGroupDetailId,
        };

        this.appService.updateQmsGroupDetail(modifiedData).subscribe({
          next: (Response: any) => {
            // Changed == to ===
            if (Response.resultType === 'S') {
              this.visibleqmsGroupDetailsAddAndEditPopup.close();
              this.ngOnInit();
            }

            // Changed let to const
            const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: Response.result,
                type: Response.resultType === 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok",
                // Simplified the null check here too
                pageName: this.message.breadcrumbData.thirdLevel ? this.message.breadcrumbData.thirdLevel : this.message.breadcrumbData.secondLevel
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: Response.resultType === 'S' ? 'Success' : 'Error',
            });

            sb.onAction().subscribe(() => {
              sb.dismiss();
            });

            this.isProcessing = false;
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      } else {
        this.updateReason = document.getElementById('updateReason2') as HTMLInputElement;
        this.updateReasonRequiredMsg = document.getElementById('updateReason-required-msg2') as HTMLInputElement;
        this.scrollToUpdateReason();
        this.updateReason.style.border = '1px solid red';
        this.updateReasonRequiredMsg.style.display = 'block';
        this.isProcessing = false;

      }
    }
  }
  focusEmpty() {
    console.log();
  }
  cancelAddAndEditQmsGroupDetailsFunction() {
    this.visibleqmsGroupDetailsAddAndEditPopup.close();
  }

  activityStatusList: any = [];
  activityStatusDropdown: any = [];
  getActivityStatusList() {
    let moduleMapping: Record<string, string> = {
      'CR': 'crStatus',
      'AU': 'auStatus',
      'OOS': 'oosStatus',
      'IN': 'inStatus',
      'QI': 'qiStatus',
      'CC': 'ccStatus',
      'DV': 'dvStatus',
      'CAPA': 'capaStatus'
    };

    const key = moduleMapping[this.selectedmoduleValue];

    if (key) {
      const data = sessionStorage.getItem(key);
      this.activityStatusList = data ? JSON.parse(data) : [];

      this.activityStatusDropdown = this.activityStatusList.map((dept: any) => ({
        valueExp: dept.codelistCode,
        displayExp: dept.codelistName
      })).sort((m: { displayExp: string }, n: { displayExp: string }) =>
        m.displayExp.trim().localeCompare(n.displayExp.trim())
      );
    }
    else {
      this.activityStatusList = [];
      this.activityStatusDropdown = [];
    }
  }

  notificationStagesSearchTxt: string = '';

  filteredNotificationStatuses$: Observable<any[]>;

  selectedNotificationStatuses: any[] = [];

  filterNotificationStages() {
    const filterValue = this.notificationStagesSearchTxt?.toLowerCase().trim();
    if (!filterValue) {
      this.filteredNotificationStatuses$ = of(this.activityStatusDropdown);
      return;
    }
    this.filteredNotificationStatuses$ = of(
      this.activityStatusDropdown.filter((status: any) =>
        status.displayExp.toLowerCase().includes(filterValue)
      )
    );
  }

  toggleAllNotificationStages(event: any) {
    if (event.checked) {
      this.selectedNotificationStatuses = [...this.activityStatusDropdown];
    } else {
      this.selectedNotificationStatuses = [];
    }
    this.onStatusChange();
  }

  areAllNotificationStagesSelected(): boolean {
    return this.activityStatusDropdown.length > 0 &&
      this.selectedNotificationStatuses.length === this.activityStatusDropdown.length;
  }

  areSomeNotificationStagesSelected(): boolean {
    return this.selectedNotificationStatuses.length > 0 &&
      this.selectedNotificationStatuses.length < this.activityStatusDropdown.length;
  }
  onStatusChange() {
    this.qmsGroupDetailsFieldData.additionalNotificationStages =
      this.selectedNotificationStatuses.map(s => s.displayExp).join(', ');
  }

  onNotificationStagesOpened(isOpen: boolean) {
    if (isOpen && this.activityStatusDropdown.length > 0) {
      setTimeout(() => {
        const searchEl = document.getElementById('notificationStagesSearch');
        if (searchEl) searchEl.focus();
      }, 100);
    }
  }

  scrollToUpdateReasonDiv: any;
  scrollToUpdateReason() {
    setTimeout(() => {
      const element = document.getElementById('scrollToUpdateReason');
      if (element) element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  }

  deleteCodelistPopop(data: any) {
    this.popupTitle = "Delete Quality Group Details";
    this.previousGroupId = data.GROUP_ID;
    this.previousGroupDetailId = data.GROUP_DETAIL_ID;
    if (this.qmsGroupUsersFieldData.deleteReason != undefined) {
      this.qmsGroupUsersFieldData.deleteReason = '';
    }
    if (this.qmsGroupDetailsFieldData.deleteReason != undefined) {
      this.qmsGroupDetailsFieldData.deleteReason = '';
    }
    this.visibleActiveAndInActivePopup = this.dialog.open(this.activeAndInActivePopup, this.activeAndInActivePopupConfig);
  }

  deleteFiledValueRequiredMsg: any;
  deleteQmsGroupDetailsValidation() {
    this.deleteFiledValueRequiredMsg = document.getElementById('deleteTextarea-required-msg1') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.isProcessing = false;
      this.deleteFiledValue.style.border = '1px solid red';
      this.deleteFiledValueRequiredMsg.style.display = 'block';
    } else {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    }
  }

  deleteReason: any = null;
  activeAndInActiveFunction() {
    this.isProcessing = true;
    this.deleteFiledValue = document.getElementById('deleteTextarea1') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteQmsGroupDetailsValidation();
      this.isProcessing = false;
    } else {
      this.isProcessing = true;
      let data = {
        groupId: this.previousGroupId,
        groupDetailId: this.previousGroupDetailId,
        deleteReason: this.qmsGroupDetailsFieldData.deleteReason
      }

      this.appService.deleteQmsGroupDetail(data).subscribe({
        next: (Response: any) => {
          if (Response.resultType == 'S') {
            this.visibleActiveAndInActivePopup.close();
            this.ngOnInit();
            this.isProcessing = false;
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok",
              pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, error: (error) => {

          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelActiveAndInActiveFunction() {
    this.visibleActiveAndInActivePopup.close();
  }

  selectedGroupId: any;
  selectedGroupDetailId: any;
  getQmsUsersDropdownData: any = [];
  groupNameValue = 'QMS';
  groupUserTitle: any;
  groupUserChosenModule: string = '';
  onQmsGroupDetailsGridRowClicked(clickedRowData: any) {
    this.isProcessing = true;
    this.qmsUsersListDropdown = [];
    this.qmsRolesListDropdown = [];
    console.log(clickedRowData);
    this.previousGroupId = clickedRowData.GROUP_ID;
    this.groupUserChosenModule = clickedRowData.MODULE;
    this.groupUserTitle = clickedRowData.MODULE + " Group Users";
    this.previousGroupDetailId = clickedRowData.GROUP_DETAIL_ID;
    this.selectedGroupId = clickedRowData.GROUP_ID;
    this.selectedGroupDetailId = clickedRowData.GROUP_DETAIL_ID;
    this.getGroupUsers(this.previousGroupDetailId);
    this.appService.getOneQmsUsersWithRolesVwDetails(this.groupNameValue).subscribe((response: any) => {
      this.getQmsUsersDropdownData = response;
      this.isProcessing = false;
      this.selectBoxForQmsUser();
    })

    this.nonorgModulesData = JSON.parse(sessionStorage.getItem('nonorgModulesData') || '{}');
    for (const moduleData of this.nonorgModulesData) {
      if (moduleData.moduleCode === clickedRowData.MODULE) {
        this.listOfDmsRoles = moduleData.groupRoles ? moduleData.groupRoles.split(",") : [];
      }
    }

    this.selectBoxForQmsRoles();

    this.visibleQmsGroupUserPopup = this.dialog.open(this.qmsGroupUsersPopup, this.qmsGroupUsersPopupConfig);

  }

  cancelFunctionForQmsGroupUsersPopup() {
    this.visibleQmsGroupUserPopup.close();
  }

  operationFlag: any;
  openQmsGroupUsersAddPopup() {
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.selectedQmsUser = [];
    this.operationFlag = 'ADD';
    this.popupTitle = "Add Quality Group User";
    this.selectedQmsUser = null;
    this.selectedQmsUserId = null;
    this.selectedQmsRole = [];
    this.selectedNotificationStatuses = [];
    this.qmsUserSearchTxt = '';
    this.isQmsUserSelectedAll = false;
    this.selectBoxForQmsUser();
    setTimeout(() => {
      this.isQmsRoleSelected = this.qmsRolesListDropdown.length == this.selectedQmsRole.length;
    })
    this.visibleQmsGroupUsersAddAndEditPopup = this.dialog.open(this.qmsGroupUsersAddAndEditPopup, this.addAndEditPopupConfig);
  }

  refreshQmsGroupUsersGridData() {
    this.getcallMethod();
  }

  previousData: any;
  previousDataGroupId: any;
  previousDataGroupDetailId: any;
  qmsGroupUsersVwByGroupId: any = [];
  previousQmsUserId: any = [];
  splitQmsRoleValues: any = [];
  filteredQmsUsersValue: any;

  openQmsGroupUsersEditPopup(editRowData: any) {
    this.isProcessing = true;
    this.operationFlag = 'EDIT';
    this.previousData = editRowData;
    this.previousDataGroupId = editRowData.groupId;
    this.previousDataGroupDetailId = editRowData.groupDetailId;
    console.log(this.previousData);
    if (this.previousData.isActive == "Y") {
      this.visibleEditButton = true;
    } else {
      this.visibleEditButton = false;
    }
    this.visibleAddButton = false;
    this.popupTitle = "Update Quality Group User";
    this.operationFlag = 'EDIT';
    this.selectedQmsRole = [];
    this.appService.getQmsGroupUsersVwByUserId(editRowData.groupDetailId, editRowData.userId).subscribe((response: any) => {
      this.qmsGroupUsersFieldData = response;
      this.qmsGroupUsersFieldData.updateReason = '';
      delete this.qmsGroupUsersFieldData.updatedOn;
      delete this.qmsGroupUsersFieldData.createdOn;

      if (this.qmsGroupUsersFieldData.userId) {
        this.qmsUsersListDropdown = [];
        this.selectedQmsUser = this.qmsGroupUsersFieldData.userId;
        this.selectBoxForQmsUser();
        const matchingUserId = this.getQmsUsersDropdownData?.find((item: any) => item.userId == this.qmsGroupUsersFieldData.userId);
        if (!matchingUserId) {
          this.oddQmsUsers = this.qmsGroupUsersFieldData.userId;
          this.qmsUsersListDropdown.push({
            valueExp: this.qmsGroupUsersFieldData.userId,
            displayExp: this.qmsGroupUsersFieldData.userName
          })
        }
        this.selectedQmsUser = this.qmsGroupUsersFieldData.userId;
      }
      if (this.qmsGroupUsersFieldData.qmsRoles) {
        this.selectedQmsRole = this.qmsGroupUsersFieldData.qmsRoles.split(",")
        setTimeout(() => { this.isQmsRoleSelected = this.qmsRolesListDropdown.length == this.selectedQmsRole.length; })
      } else {
        this.selectedQmsRole = [];
        setTimeout(() => { this.isQmsRoleSelected = this.qmsRolesListDropdown.length == this.selectedQmsRole.length; })
      }

      this.isProcessing = false;
    });

    this.visibleQmsGroupUsersAddAndEditPopup = this.dialog.open(this.qmsGroupUsersAddAndEditPopup, this.addAndEditPopupConfig);

  }

  qmsUsersListDropdown: any = [];
  selectedQmsUser: any = null;
  selectedQmsUserValue: any = null;
  selectedQmsUserId: any = null;
  filteredQmsUsersList: any[] = [];
  isQmsUserSelectedAll: boolean = false;
  qmsUserSearchTxt: string = '';

  selectBoxForQmsUser() {
    this.qmsUsersListDropdown = [];

    const existingUserIds = new Set(this.qmsGroupsUsersList.map((u: any) => Number(u.userId)));

    for (const user of this.getQmsUsersDropdownData) {
      const isUserBeingEdited = this.operationFlag === 'EDIT' && Number(user.userId) === Number(this.selectedQmsUser);

      const isAlreadyInGrid = existingUserIds.has(Number(user.userId));
      const x = this.groupUserChosenModule;

      if ((!isAlreadyInGrid || isUserBeingEdited) && ((x == 'CR' && user.qualityUserRoles?.includes('Change Request User')) || (x == 'CAPA' && user.qualityUserRoles?.includes('CAPA User')) || (x == 'DV' && user.qualityUserRoles?.includes('Deviation User')) || (x == 'IN' && user.qualityUserRoles?.includes('Incident User')) || (x == 'QI' && user.qualityUserRoles?.includes('Quality Issue User')) || (x == 'CC' && user.qualityUserRoles?.includes('Customer Complaint User')) || (x == 'AU' && user.qualityUserRoles?.includes('Audit User')) || (x == 'OOS' && user.qualityUserRoles?.includes('Out of Specification User')))) {
        this.qmsUsersListDropdown.push({
          valueExp: user.userId,
          displayExp: user.userName
        });
      }
    }

    this.filteredQmsUsersList = [...this.qmsUsersListDropdown];
  }
  filterQmsUsersList() {
    const search = (this.qmsUserSearchTxt || '').toLowerCase().trim();
    if (!search) {
      this.filteredQmsUsersList = [...this.qmsUsersListDropdown];
      return;
    }

    this.filteredQmsUsersList = this.qmsUsersListDropdown.filter((item: any) => {
      const isSelected = Array.isArray(this.selectedQmsUser)
        ? this.selectedQmsUser.includes(item.valueExp)
        : this.selectedQmsUser === item.valueExp;
      return item.displayExp.toLowerCase().includes(search) || isSelected;
    });
  }

  getSelectedQmsUsersLabel(): string {
    if (!this.selectedQmsUser || (Array.isArray(this.selectedQmsUser) && this.selectedQmsUser.length === 0)) {
      return 'Select';
    }
    if (!Array.isArray(this.selectedQmsUser)) {
      const single = this.qmsUsersListDropdown.find((u: any) => u.valueExp === this.selectedQmsUser);
      return single ? single.displayExp : 'Select';
    }
    const selectedNames = this.qmsUsersListDropdown
      .filter((u: any) => this.selectedQmsUser.includes(u.valueExp))
      .map((u: any) => u.displayExp);

    return selectedNames.length > 2
      ? `${selectedNames[0]} (+${selectedNames.length - 1} more)`
      : selectedNames.join(', ');
  }

  toggleAllQmsUsers() {
    if (this.isQmsUserSelectedAll) {
      const allIds = this.qmsUsersListDropdown.map((u: any) => u.valueExp);
      if (allIds.length > 50) {
        this.selectedQmsUser = allIds.slice(0, 50);
        alert("Selection exceeds limit. Only the first 50 users have been selected.");
      } else {
        this.selectedQmsUser = allIds;
      }
    } else {
      this.selectedQmsUser = [];
    }
  }

  qmsRolesListDropdown: any = [];
  selectedQmsRole: any = [];
  selectedQmsRoleValue: any = [];
  selectedQmsRoleId: any = [];
  selectBoxForQmsRoles() {
    for (const role of this.listOfDmsRoles) {
      this.qmsRolesListDropdown.push({
        valueExp: role,
        displayExp: role
      });
    }
  }

  usersValueRequiredMsg: any;
  qmsRolesValueRequiredMsg: any;
  updateRequired: any;
  updateRequiredMsg: any


  qmsGroupUsersFieldValidation() {
    this.usersValueRequiredMsg = document.getElementById('users-required-msg') as HTMLInputElement;
    this.qmsRolesValueRequiredMsg = document.getElementById('qmsRoles-required-msg') as HTMLInputElement;
    this.updateRequiredMsg = document.getElementById('update-required-msg') as HTMLInputElement;

    if (this.selectedQmsUser) {
      this.usersValueRequiredMsg.style.display = 'none';
    } else {
      this.usersValueRequiredMsg.style.display = 'block';
    }

    if (this.visibleEditButton) {
      if (this.qmsGroupUsersFieldData.updateReason) {
        this.updateRequiredMsg.style.display = 'none';
      } else {
        this.updateRequiredMsg.style.display = 'block';
      }
    }

    if (this.selectedQmsRole.length < 1) {
      this.qmsRolesValueRequiredMsg.style.display = 'block';
    } else {
      this.qmsRolesValueRequiredMsg.style.display = 'none';
    }
  }

  commaSepratedValues: any = [];
  addAndEditFunctionForQmsGroupUsers(qmsGroupUsersFieldData: any) {
    this.updateRequiredMsg = document.getElementById('update-required-msg') as HTMLInputElement;
    const updateTextArea = document.getElementById('update-text') as HTMLTextAreaElement;
    if (!this.selectedQmsUser || (Array.isArray(this.selectedQmsUser) && this.selectedQmsUser.length === 0)) {
      this.showSnackBar("Please select at least one user", "E");
      return;
    }
    if (this.selectedQmsRole.length < 1) {
      this.showSnackBar("Please select at least one role", "E");
      return;
    }
    if (this.visibleEditButton) {
      if (!this.qmsGroupUsersFieldData.updateReason || this.qmsGroupUsersFieldData.updateReason.trim() === '') {
        if (this.updateRequiredMsg) this.updateRequiredMsg.style.display = 'block';
        if (updateTextArea) updateTextArea.style.border = '1px solid red';
        return;
      } else {
        if (this.updateRequiredMsg) this.updateRequiredMsg.style.display = 'none';
        if (updateTextArea) updateTextArea.style.border = '';
      }
    }

    this.isProcessing = true;
    const rolesString = this.selectedQmsRole.join(',');

    if (this.operationFlag === 'ADD' && Array.isArray(this.selectedQmsUser)) {
      from(this.selectedQmsUser).pipe(
        concatMap((singleUserId: any) => {
          const payload = {
            groupId: this.message.masterDetails[0].GROUP_ID,
            groupDetailId: this.previousGroupDetailId,
            userId: singleUserId,
            qmsRoles: rolesString
          };
          return this.appService.createQmsGroupUsers(payload);
        })
      ).subscribe({
        next: (res: any) => console.log('Assigned user:', res),
        complete: () => {
          this.showSnackBar("Users assigned successfully", "S");
          this.visibleQmsGroupUsersAddAndEditPopup.close();
          this.getGroupUsers(this.previousGroupDetailId);
          this.isProcessing = false;
        },
        error: (err) => {
          this.isProcessing = false;
          this.showSnackBar("An error occurred during bulk assignment", "E");
        }
      });
    }
    else {
      const payload = {
        ...qmsGroupUsersFieldData,
        groupId: this.message.masterDetails[0].GROUP_ID,
        groupDetailId: this.previousGroupDetailId,
        userId: Array.isArray(this.selectedQmsUser) ? this.selectedQmsUser[0] : this.selectedQmsUser,
        qmsRoles: rolesString
      };
      this.appService.updateQmsGroupUsers(payload).subscribe((res: any) => {
        if (res.resultType === 'S') {
          this.showSnackBar(res.result, "S");
          this.visibleQmsGroupUsersAddAndEditPopup.close();
          this.getGroupUsers(this.previousGroupDetailId);
        } else {
          this.showSnackBar(res.result, "E");
        }
        this.isProcessing = false;
      });
    }
  }


  cancelAddAndEditFunctionForQmsGroupUsers() {
    this.visibleQmsGroupUsersAddAndEditPopup.close();
  }

  deleteQmsGroupUsersValidation() {
    this.deleteFiledValueRequiredMsg = document.getElementById('deleteTextarea-required-msg2') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.isProcessing = false;
      this.deleteFiledValue.style.border = '1px solid red';
      this.deleteFiledValueRequiredMsg.style.display = 'block';
    } else {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    }
  }

  deleteQmsGroupUsersGroupId: any;
  deleteQmsGroupUsersGroupDetailId: any;
  deleteQmsGroupUsersId: any;
  openQmsGroupUsersDeletePopup(deleteRowData: any) {
    console.log(deleteRowData);
    this.operationFlag = 'DELETE';
    this.popupTitle = "Delete Quality Group User";
    this.deleteQmsGroupUsersGroupId = deleteRowData.groupId;
    this.deleteQmsGroupUsersGroupDetailId = deleteRowData.groupDetailId;
    this.deleteQmsGroupUsersId = deleteRowData.userId;
    if (this.qmsGroupUsersFieldData.deleteReason != undefined) {
      this.qmsGroupUsersFieldData.deleteReason = '';
    }
    this.visibleQmsGroupUsersDeletePopup = this.dialog.open(this.qmsGroupUsersDeletePopup, this.qmsGroupUsersDeletePopupConfig);
  }

  deleteFiledValue: any;
  deleteFunction(qmsGroupUsersFieldData: any) {
    this.isProcessing = true;
    this.deleteFiledValue = document.getElementById('deleteTextarea2') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteQmsGroupUsersValidation();
      this.isProcessing = false;
    } else if (this.operationFlag == "DELETE") {
      qmsGroupUsersFieldData.userId = this.deleteQmsGroupUsersId;
      qmsGroupUsersFieldData.groupId = this.deleteQmsGroupUsersGroupId;
      qmsGroupUsersFieldData.groupDetailId = this.deleteQmsGroupUsersGroupDetailId;
      qmsGroupUsersFieldData.deleteReason = this.qmsGroupUsersFieldData.deleteReason;
      this.appService.deleteQmsGroupUsers(qmsGroupUsersFieldData).subscribe({
        next: (Response: any) => {
          if (Response.resultType == 'S') {
            this.visibleQmsGroupUsersDeletePopup.close();
            this.isProcessing = false;
            this.getGroupUsers(this.previousGroupDetailId);
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });

        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelDeleteFunction() {
    this.visibleQmsGroupUsersDeletePopup.close();
  }

  activeInactiveLabel: string;
  activeInactiveButtonLabel: string;
  errorMsgContent: string;
  activeInactiveGroupDetailId: number;
  groupActionFlag: boolean;

  openActiveAndInActivePopup(qmsGroupActiveInactiveRowData: any) {
    if (qmsGroupActiveInactiveRowData.IS_ACTIVE) {
      this.popupTitle = qmsGroupActiveInactiveRowData.MODULE + " Group Details Inactivation";
      this.activeInactiveLabel = "Reason for Inactivation";
      this.activeInactiveButtonLabel = "Inactivate";
      this.errorMsgContent = "Inactivation";
      this.groupActionFlag = false;
    } else {
      this.popupTitle = qmsGroupActiveInactiveRowData.MODULE + " Group Details Activation";
      this.activeInactiveLabel = "Reason for Activation";
      this.activeInactiveButtonLabel = "Activate";
      this.errorMsgContent = "Activation";
      this.groupActionFlag = true;
    }
    this.activeInactiveGroupDetailId = qmsGroupActiveInactiveRowData.GROUP_DETAIL_ID;
    this.qmsGroupUsersFieldData.groupActiveInactiveReason = "";
    this.visibleQmsGroupActiveInactivePopup = this.dialog.open(this.qmsGroupActiveInactivePopup, this.qmsGroupActiveInactivePopupConfig);
  }

  cancelQmsGroupActiveInActiveFunction() {
    this.visibleQmsGroupActiveInactivePopup.close();
  }

  groupActiveInactiveReasonValue: any;
  groupActiveInactiveReasonRequiredMsg: any;
  qmsGroupActiveInactiveValidation() {
    this.groupActiveInactiveReasonValue = document.getElementById('groupActiveInactiveReason') as HTMLInputElement;
    this.groupActiveInactiveReasonRequiredMsg = document.getElementById('groupActiveInactiveReason-required-msg') as HTMLInputElement;
    if (this.qmsGroupUsersFieldData.groupActiveInactiveReason == "") {
      this.groupActiveInactiveReasonValue.style.border = '1px solid red';
      this.groupActiveInactiveReasonRequiredMsg.style.display = 'block';
    } else {
      this.groupActiveInactiveReasonValue.style.border = 'none';
      this.groupActiveInactiveReasonRequiredMsg.style.display = 'none';
    }
  }

  displayMessage: any;
  displayResultType: any;
  displaySuccessMessage: any;
  displayErrorMessage: any;
  qmsGroupActiveInActiveFunction() {
    this.isProcessing = true;
    if (this.qmsGroupUsersFieldData.groupActiveInactiveReason == "") {
      this.qmsGroupActiveInactiveValidation();
      this.isProcessing = false;
    } else {
      const isActiveValue = this.groupActionFlag ? 'ACTIVATE' : 'INACTIVATE';
      let qmsGroupActiveInactiveData = {
        groupDetailId: this.activeInactiveGroupDetailId,
        isActive: isActiveValue,
        inActiveReason: this.qmsGroupUsersFieldData.groupActiveInactiveReason,
      };
      this.appService.activeInactiveQmsGroupDetail(qmsGroupActiveInactiveData).subscribe({
        next: (Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == 'S') {
            this.visibleQmsGroupActiveInactivePopup.close();
            this.getcallMethod();
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  activeInactiveGroupId: any;
  activeInactiveuserId: any;
  openActiveAndInActivePopupForUser(qmsGroupUsersActiveInactiveRowData: any) {
    if (qmsGroupUsersActiveInactiveRowData.isActive == "Y") {
      this.popupTitle = "Group User Inactivation";
      this.activeInactiveLabel = "Reason for Inactivation";
      this.activeInactiveButtonLabel = "Inactivate";
      this.errorMsgContent = "Inactivation";
      this.groupActionFlag = false;
    } else {
      this.popupTitle = "Group User Activation";
      this.activeInactiveLabel = "Reason for Activation";
      this.activeInactiveButtonLabel = "Activate";
      this.errorMsgContent = "Activation";
      this.groupActionFlag = true;
    }
    this.activeInactiveGroupDetailId = qmsGroupUsersActiveInactiveRowData.groupDetailId;
    this.activeInactiveGroupId = qmsGroupUsersActiveInactiveRowData.groupId;
    this.activeInactiveuserId = qmsGroupUsersActiveInactiveRowData.userId;
    this.qmsGroupUsersFieldData.groupActiveInactiveReason = "";
    this.visibleQmsGroupUserActiveInactivePopup = this.dialog.open(this.qmsGroupUserActiveInactivePopup, this.qmsGroupUserActiveInactivePopupConfig);
  }

  cancelQmsGroupUserActiveInActiveFunction() {
    this.visibleQmsGroupUserActiveInactivePopup.close();
  }

  qmsGroupUserActiveInActiveFunction(qmsGroupUsersFieldData: any) {
    this.isProcessing = true;
    if (this.qmsGroupUsersFieldData.groupActiveInactiveReason == "") {
      this.qmsGroupActiveInactiveValidation();
      this.isProcessing = false;
    } else {
      const isActiveValue = this.groupActionFlag ? 'ACTIVATE' : 'INACTIVATE';
      let qmsGroupUserActiveInactiveData = {
        groupDetailId: this.activeInactiveGroupDetailId,
        groupId: this.activeInactiveGroupId,
        userId: this.activeInactiveuserId,
        isActive: isActiveValue,
        inActiveReason: this.qmsGroupUsersFieldData.groupActiveInactiveReason,
      };
      this.appService.qmsGroupUserActiveInactive(qmsGroupUserActiveInactiveData).subscribe({
        next: (Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == 'S') {
            this.visibleQmsGroupUserActiveInactivePopup.close();
            this.isProcessing = false;
            this.getGroupUsers(this.previousGroupDetailId);
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  /* Start Quality Group Detail Type Settings */
  groupdetailSettingsTooltipTitle: any;
  getRowData(rowData: any) {
    this.groupdetailSettingsTooltipTitle = "Open " + rowData.MODULE + " Type Settings";
  }

  qmsGroupDetailTypeSettingsFieldData: any = {};
  codelistCodeData: any = [];
  codelistCodeFindingData: any = [];
  getQmsGroupDetailTypeSettingsVwDetails: any = [];
  getQmsGroupDetailFindingsTypeSettingsVwDetails: any = [];
  titleOfQmsGroupDetailSetting: any;
  onClickedGroupDetailId: any;
  openQmsGroupDetailTypeSettingsPopup(list: any) {
    this.codelistCodeFindingData = [];
    this.codelistCodeData = [];
    this.isProcessing = true;
    this.titleOfQmsGroupDetailSetting = list.MODULE;
    this.onClickedGroupDetailId = list.GROUP_DETAIL_ID;
    if (list.MODULE != undefined) {

      this.appService.getCodeListsByGroup(list.MODULE + "_TYPE").subscribe((response: any) => {
        this.codelistCodeData = response;
        this.appService.getCodeListsByGroup("SEVERITY").subscribe((response1: any) => {
          for (const item of response1) {
            item.codelistName = `Findings-${item.codelistName}`;
            item.codelistCode = `Findings-${item.codelistCode}`;
          }
          if (list.MODULE == 'AU') {
            this.codelistCodeFindingData = response1;
            this.codelistCodeData = [...this.codelistCodeData, ...this.codelistCodeFindingData];
          }

          if (this.codelistCodeData.length > 0) {
            this.selectBoxeForTypeDropdown();
            this.appService.getTypeSettingsByGrpIdGrpDetailId(this.message.masterDetails[0].GROUP_ID, list.GROUP_DETAIL_ID).subscribe((response: any) => {
              this.getQmsGroupDetailTypeSettingsVwDetails = response;
            })
            this.visibleQmsGroupDetailTypeSettingsPopup = this.dialog.open(this.qmsGroupDetailTypeSettingsPopup, this.addAndEditPopupConfig);
            this.isProcessing = false;
          } else {
            this.visibleQmsGroupDetailTypeSettingsPopup = this.dialog.open(this.qmsGroupDetailTypeSettingsPopup, this.addAndEditPopupConfig);
            this.isProcessing = false;
          }
        });
      })
    }
  }

  selectedTypeValue: any = null;
  typeDropdownData: any = [];
  selectBoxeForTypeDropdown() {
    this.typeDropdownData = [];

    for (const codelist of this.codelistCodeData) {
      this.typeDropdownData.push({
        valueExp: codelist.codelistCode,
        displayExp: codelist.codelistName
      });
    }
  }
  typeValue: any;

  onDeSelect(item: any) {

    this.typeValue = "";

  }
  qmsGroupDetailTypeSettingsVwChildCheckBoxs: boolean = false;
  qmsGroupDetailTypeSettingsVwPriviousValue: any;
  qmsGroupDetailTypeSettingsVwChildCheckBoxChecked(e: any, listOfUsersVwDetails: any, idx: any) {
    if (e.target.checked) {
      if (this.qmsGroupDetailTypeSettingsVwPriviousValue != undefined) {
        this.getQmsGroupDetailTypeSettingsVwDetails[this.qmsGroupDetailTypeSettingsVwPriviousValue].qmsGroupDetailTypeSettingsVwChildCheckBoxs = false;
      }
      listOfUsersVwDetails.qmsGroupDetailTypeSettingsVwChildCheckBoxs = true;
    } else {
      listOfUsersVwDetails.qmsGroupDetailTypeSettingsVwChildCheckBoxs = false;
    }
    this.qmsGroupDetailTypeSettingsVwPriviousValue = idx;
  }

  refreshQMSGroupDetailTypeSettingsGridData() {
    this.isProcessing = true;
    if (this.codelistCodeData.length > 0) {
      this.appService.getTypeSettingsByGrpIdGrpDetailId(this.message.masterDetails[0].GROUP_ID, this.onClickedGroupDetailId).subscribe((response: any) => {
        this.getQmsGroupDetailTypeSettingsVwDetails = response;
      })
    } else {
      this.visibleQmsGroupDetailTypeSettingsPopup.close();
    }
    this.isProcessing = false;
  }

  cancelQmsGroupDetailTypeSettingsPopupFunction() {
    this.visibleQmsGroupDetailTypeSettingsPopup.close();
  }

  openQMSGroupDetailTypeSettingsAddPopup() {
    this.operationFlag = 'ADD';
    this.popupTitle = "Create " + this.titleOfQmsGroupDetailSetting + " Type Settings";
    this.selectedTypeValue = null;
    this.qmsGroupDetailTypeSettingsFieldData.type = undefined;
    this.qmsGroupDetailTypeSettingsFieldData.toBeStartedInDays = null;
    this.qmsGroupDetailTypeSettingsFieldData.toBeClosedInDays = null;
    this.qmsGroupDetailTypeSettingsFieldData.updateReason = undefined;
    this.qmsGroupDetailTypeSettingsFieldData.recalculateClosureDateWhenActivityStarts = false;
    this.visibleEditButton = false;
    this.visibleqmsGroupDetailTypeSettingsAddAndEditPopup = this.dialog.open(this.qmsGroupDetailTypeSettingsAddAndEditPopup, this.addAndEditPopupConfig);
  }

  editGroupDetailId: any;
  editSettingsId: any;
  onClickedGroupDetailSettingsId: any;
  filteredTypeValue: any;
  openQMSGroupDetailTypeSettingsEditPopup(editData: any) {
    this.isProcessing = true;
    this.operationFlag = 'EDIT';
    this.popupTitle = "Update " + this.titleOfQmsGroupDetailSetting + " Type Settings";
    this.visibleEditButton = true;
    this.onClickedGroupDetailId = editData.groupDetailId;
    this.onClickedGroupDetailSettingsId = editData.settingsId;
    this.editSettingsId = editData.settingsId;
    this.appService.getQmsGroupDetailTypeSettingsVwDetailsBySettingsId(this.message.masterDetails[0].GROUP_ID, editData.groupDetailId, editData.settingsId).subscribe((response: any) => {

      if (response.type) {
        const matchingType = this.codelistCodeData?.find((item: any) => item.codelistCode == response.type);
        if (!matchingType) {
          this.oddTypeValue = response.type;
          this.typeDropdownData.push({
            valueExp: response.type,
            displayExp: response.type
          })
        }
        this.selectedTypeValue = response.type;
      }


      this.qmsGroupDetailTypeSettingsFieldData.type = response.type;
      this.qmsGroupDetailTypeSettingsFieldData.toBeStartedInDays = response.toBeStartedInDays;
      this.qmsGroupDetailTypeSettingsFieldData.toBeClosedInDays = response.toBeClosedInDays;
      this.qmsGroupDetailTypeSettingsFieldData.recalculateClosureDateWhenActivityStarts = response.recalculateClosureDateWhenActivityStarts == "Y";
      this.qmsGroupDetailTypeSettingsFieldData.updateReason = undefined;
      this.isProcessing = false;
    })
    this.visibleqmsGroupDetailTypeSettingsAddAndEditPopup = this.dialog.open(this.qmsGroupDetailTypeSettingsAddAndEditPopup, this.addAndEditPopupConfig);
  }

  onQmsGroupDetailTypeSettingsFocusout() {
    this.deleteFiledValue = document.getElementById('deleteTextarea3') as HTMLInputElement;
    this.deleteFiledValueRequiredMsg = document.getElementById('deleteTextarea-required-msg3') as HTMLInputElement;

    if (this.deleteFiledValue.value != undefined && this.deleteFiledValue.value != '' && this.deleteFiledValue.value != null) {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    } else {
      this.deleteFiledValue.style.border = '1px solid red';
      this.deleteFiledValueRequiredMsg.style.display = 'block';
    }
  }

  onFieldFocusout() {
    this.updateReason = document.getElementById('updateReason3') as HTMLInputElement;
    this.updateReasonRequiredMsg = document.getElementById('updateReason-required-msg3') as HTMLInputElement;

    if (this.updateReason.value != '' && this.updateReason.value != null && this.updateReason.value != undefined) {
      this.updateReason.style.border = 'none';
      this.updateReasonRequiredMsg.style.display = 'none';
    } else {
      this.updateReason.style.border = '1px solid red';
      this.updateReasonRequiredMsg.style.display = 'block';
    }
  }

  typeValueRequiredMsg: any;
  qmsGroupDetailTypeSettingsFieldValidation() {
    this.typeValueRequiredMsg = document.getElementById('type-required-msg') as HTMLInputElement;
    if (this.selectedTypeValue) {
      this.typeValueRequiredMsg.style.display = 'none';
    } else {
      this.typeValueRequiredMsg.style.display = 'block';
    }
  }

  private refreshSettingsAndGrid(): void {

    this.appService.getCodeListsByGroup(this.titleOfQmsGroupDetailSetting + "_TYPE").subscribe({
      next: (response: any) => {
        this.codelistCodeData = response;
        this.fetchSeverityAndGridData();
      }
    });
  }

  private fetchSeverityAndGridData(): void {
    this.appService.getCodeListsByGroup("SEVERITY").subscribe({
      next: (response1: any) => {
        for (const element of response1) {
          element.codelistName = `Findings-${element.codelistName}`;
          element.codelistCode = `Findings-${element.codelistCode}`;
        }

        if (this.titleOfQmsGroupDetailSetting === 'AU') {
          this.codelistCodeFindingData = response1;
          this.codelistCodeData = [...this.codelistCodeData, ...this.codelistCodeFindingData];
        }

        if (this.codelistCodeData.length > 0) {
          this.selectBoxeForTypeDropdown();
          this.appService.getTypeSettingsByGrpIdGrpDetailId(
            this.message.masterDetails[0].GROUP_ID, this.onClickedGroupDetailId
          ).subscribe((res: any) => this.getQmsGroupDetailTypeSettingsVwDetails = res);
        } else {
          this.visibleQmsGroupDetailTypeSettingsPopup.close();
        }
        this.isProcessing = false;
      }
    });
  }
  private showSuccessSnackBar(Response: any): void {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: 5000,
      data: {
        message: Response.result,
        type: Response.resultType === 'S' ? 'Success' : 'Error',
        buttonLabel: "Ok"
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: Response.resultType === 'S' ? 'Success' : 'Error',
    });
    sb.onAction().subscribe(() => sb.dismiss());
  }
  addAndEditFunctionForQmsGroupDetailTypeSettings(data: any) {
    this.isProcessing = true;

    // 1. Early Return for validation
    if (!this.selectedTypeValue) {
      this.qmsGroupDetailTypeSettingsFieldValidation();
      this.isProcessing = false;
      return;
    }

    const obj = {
      ...data,
      groupId: this.message.masterDetails[0].GROUP_ID,
      groupDetailId: this.onClickedGroupDetailId,
      type: this.selectedTypeValue ?? null,
      recalculateClosureDateWhenActivityStarts: data.recalculateClosureDateWhenActivityStarts ? "Y" : "N"
    };

    if (this.operationFlag === 'ADD') {
      this.appService.createQmsGroupDetailTypeSettings(obj).subscribe({
        next: (res: any) => this.handleApiResponse(res),
        error: (err: any) => { this.isProcessing = false; throw err; }
      });
    } else {
      // Check for update reason in EDIT mode
      if (!this.qmsGroupDetailTypeSettingsFieldData.updateReason) {
        this.showUpdateReasonError();
        return;
      }

      delete data.createdOn;
      delete data.updatedOn;
      const updateObj = { ...obj, settingsId: this.onClickedGroupDetailSettingsId };

      this.appService.updateQmsGroupDetailTypeSettings(updateObj).subscribe({
        next: (res: any) => this.handleApiResponse(res),
        error: (err: any) => { this.isProcessing = false; throw err; }
      });
    }
  }

  private handleApiResponse(Response: any): void {
    if (Response.resultType === 'S') {
      this.refreshSettingsAndGrid();
    }
    this.showSuccessSnackBar(Response);
    this.visibleqmsGroupDetailTypeSettingsAddAndEditPopup.close();
    this.isProcessing = false;
  }

  private showUpdateReasonError(): void {
    this.updateReason = document.getElementById('updateReason3') as HTMLInputElement;
    this.updateReasonRequiredMsg = document.getElementById('updateReason-required-msg3') as HTMLInputElement;
    this.updateReason.style.border = '1px solid red';
    this.updateReasonRequiredMsg.style.display = 'block';
    this.isProcessing = false;
  }

  cancelAddAndEditFunctionForQmsGroupDetailTypeSettings() {
    this.visibleqmsGroupDetailTypeSettingsAddAndEditPopup.close();
  }

  openQMSGroupDetailTypeSettingsDeletePopup(list: any) {
    this.operationFlag = 'DELETE';
    this.onClickedGroupDetailSettingsId = list.settingsId;
    this.qmsGroupDetailTypeSettingsFieldData.deleteReason = undefined;
    this.popupTitle = "Delete " + this.titleOfQmsGroupDetailSetting + " Type Settings";
    this.visibleQmsGroupDetailTypeSettingsDeletePopup = this.dialog.open(this.qmsGroupDetailTypeSettingsDeletePopup, this.qmsGroupUsersDeletePopupConfig);
  }

  deleteValidation() {
    this.deleteFiledValueRequiredMsg = document.getElementById('deleteTextarea-required-msg3') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.isProcessing = false;
      this.deleteFiledValue.style.border = '1px solid red';
      this.deleteFiledValueRequiredMsg.style.display = 'block';
    } else {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    }
  }

  deleteQmsGroupDetailTypeSettingsFunction(deleteData: any) {
    this.isProcessing = true;
    this.deleteFiledValue = document.getElementById('deleteTextarea3') as HTMLInputElement;

    if (this.deleteFiledValue.value === '') {
      this.deleteValidation();
      this.isProcessing = false;
      return;
    }
    deleteData.settingsId = this.onClickedGroupDetailSettingsId;
    deleteData.deleteReason = this.qmsGroupDetailTypeSettingsFieldData.deleteReason;

    this.appService.deleteQmsGroupDetailTypeSettings(deleteData).subscribe({
      next: (Response: any) => {
        if (Response.resultType === 'S') {
          this.refreshSettingsAndGrid();
        }

        this.showSuccessSnackBar(Response);
        this.visibleQmsGroupDetailTypeSettingsDeletePopup.close();
        this.isProcessing = false;
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  cancelQmsGroupDetailTypeSettingsDeleteFunction() {
    this.visibleQmsGroupDetailTypeSettingsDeletePopup.close();
  }

  onRiskCalculationChange() {
    this.qmsGroupDetailsFieldData.riskFormula = "";
  }

  dropDownForDesignation: any = [];
  dropDownForDepartment: any = [];
  designationListDropdown: any = [];
  departmentListDropdown: any = [];

  selectBoxForDesignation() {
    this.designationListDropdown = [];
    this.designationListDropdown = this.dropDownForDesignation?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })) || []
  }

  selectBoxForDepartment() {
    this.departmentListDropdown = [];
    this.departmentListDropdown = this.dropDownForDepartment?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })) || []
  }

  @ViewChild('searchUsersPopup', { static: true }) searchUsersPopup: TemplateRef<any>;
  visibleSearchUsersPopup: MatDialogRef<TemplateRef<any>>;

  searchUsersPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  qmsUsersList: any = [];
  selectedUsersArray: any = [];
  showUserSearchGrid: boolean;
  searchByUserName: any;
  searchByFirstName: any;
  searchByLastName: any;
  searchByEmail: any;
  searchByemailAddress: any;
  searchByDesignationCode: any = null;
  searchByDepartmentCode: any = null;
  searchingByStatusCode: any = [];
  designationCodeDropdown: any = [];
  departmentCodeDropdown: any = [];
  searchUserParentCheckBox: boolean = false;
  currentIndex: any;
  previousIndex: any = null;
  opensSearchUsersPopup() {
    this.showUserSearchGrid = false;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchByEmail = null;
    this.searchByDesignationCode = null;
    this.searchByDepartmentCode = null;
    this.popupTitle = "Search User(s)";
    this.visibleSearchUsersPopup = this.dialog.open(this.searchUsersPopup, this.searchUsersPopupConfig);
  }

  resetSearchUsers() {
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchByEmail = null;
    this.searchByDesignationCode = null;
    this.searchByDepartmentCode = null;
    this.selectedUsersArray = [];
    this.showUserSearchGrid = false;
  }

  getUsers() {
    this.visibleSearchUsersPopup.close();
  }

  cancelSearchUsersPopup() {
    this.visibleSearchUsersPopup.close();
  }

  searchUsersFunc() {
    this.isProcessing = true;
    let data = {
      userName: this.searchByUserName ? this.searchByUserName.toUpperCase() : "",
      firstName: this.searchByFirstName,
      lastName: this.searchByLastName,
      emailAddress: this.searchByEmail,
      designationCode: this.searchByDesignationCode ?? null,
      departmentCode: this.searchByDepartmentCode ?? null,
      status: "active"
    };
    this.appService.getOneQmsUsersVwDetails(data).subscribe((response: any) => {
      for (let x of response) {
        x.isAdUser = x.isAdUser == 'Y'
      }
      this.qmsUsersList = response;
      this.qmsUsersList.sort((a: any, b: any) => a.userName.localeCompare(b.userName));
      this.showUserSearchGrid = true;
      this.isProcessing = false;
    })
  }
  // ✅ Parent checkbox: Select / Deselect All users
  onParentCheckBoxChanged(event: any) {
    const isChecked = event.target.checked;

    this.searchUserParentCheckBox = isChecked;
    this.selectedUsersArray = [];

    // Loop through all users
    this.qmsUsersList.forEach((user: any) => {
      if (user.emailAddress) {
        user.searchUserChildCheckBox = isChecked; // Check/uncheck child
        if (isChecked) {
          this.selectedUsersArray.push({
            userId: user.userId,
            userName: user.userName
          });
        }
      }
    });
  }
  // ✅ Child checkbox - Single row select / deselect
  onChildCheckBoxChanged(event: any, user: any, idx: number) {
    const isChecked = event.target.checked;
    user.searchUserChildCheckBox = isChecked;

    if (isChecked) {
      // Add user if not already selected
      const exists = this.selectedUsersArray.some(
        (storedUser: any) => storedUser.userId === user.userId
      );
      if (!exists) {
        this.selectedUsersArray.push({
          userId: user.userId,
          userName: user.userName
        });
      }
    } else {
      // Remove user if unchecked
      this.selectedUsersArray = this.selectedUsersArray.filter(
        (storedUser: any) => storedUser.userId !== user.userId
      );
    }

    // ✅ Auto-update parent checkbox:
    const totalUsers = this.qmsUsersList.filter((u: any) => u.emailAddress).length;
    const selectedUsers = this.qmsUsersList.filter((u: any) => u.searchUserChildCheckBox).length;

    // Parent checkbox is checked only when *all* are selected
    this.searchUserParentCheckBox = selectedUsers === totalUsers && totalUsers > 0;

    console.log('Child Changed → Selected Users:', this.selectedUsersArray);
  }
  onUserRemoved(index: any) {
    if (index >= 0) this.selectedUsersArray.splice(index, 1);
  }

  removeAllUsers() {
    this.selectedUsersArray = [];
  }

  onAdditionalNotificationReqdChange() {
    this.selectedUsersArray = [];
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.documentTypeCall.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA! < valueB!) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA! > valueB!) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;
  @ViewChild(StaticAuditTrailComponent) staticAuditTrailComponent!: StaticAuditTrailComponent;

  openAuditTrail(grid: any, viewType: any, group_or_user_or_type: any) {
    console.log("grid==", grid);
    if (grid == 'DETAIL') {
      this.auditTrail.refNo = viewType == 'overAll' ? null : group_or_user_or_type.GROUP_DETAIL_ID;
      this.auditTrail.groupId = this.message.masterDetails[0].GROUP_ID;
      this.auditTrail.gridName = 'QMS_GROUP_DETAIL';
      this.auditTrail.report_And_Popup_Name = 'Quality Group Detail Audit Trail';
      this.dynamicAuditTrailComponent.triggerTrail(group_or_user_or_type);
    } else if (grid == 'USER') {
      this.message.tableOrView_Name = "QMS_GROUP_USERS_AU_VW";
      this.message.columnList_DB = "CREATED_TS,END_TS,ACTION_FLAG,EMAIL_ADDRESS,USER_NAME,FIRST_NAME,LAST_NAME,DESIGNATION_CODE,DESIGNATION,DEPARTMENT_CODE,DEPARTMENT,QMS_ROLES,IS_ACTIVE,IS_USER_ACTIVE,INACTIVATE_REASON,ASSIGNED_ON,ASSIGNED_BY_USER,UPDATED_ON,UPDATED_BY_USER,UPDATE_REASON,DELETED_BY_USER,DELETED_REASON";
      this.message.columnList_UI = "Created Timestamp,End Timestamp,Action,Email Address,User Name,First Name,Last Name,Designation Code,Designation,Department Code,Department,QMS Roles,Is Active,Is User Active,Inactivate Reason,Assigned On, Assigned By User,Updated On,Updated By,Update Reason,Deleted By User,Deleted Reason";
      this.message.whereClause_AU = viewType == 'overAll' ? " AND GROUP_ID = " + this.message.masterDetails[0].GROUP_ID + " AND GROUP_DETAIL_ID = " + this.selectedGroupDetailId : " AND GROUP_DETAIL_ID = " + group_or_user_or_type.groupDetailId + " AND USER_ID = " + group_or_user_or_type.userId;
      this.message.columnList_Report = this.message.columnList_UI;
      this.message.whereClause_Report = viewType == 'overAll' ? " WHERE GROUP_ID = " + this.message.masterDetails[0].GROUP_ID + " AND GROUP_DETAIL_ID = " + this.selectedGroupDetailId : " WHERE GROUP_DETAIL_ID = " + group_or_user_or_type.groupDetailId + " AND USER_ID = " + group_or_user_or_type.userId;
      this.message.report_And_Popup_Name = "Quality Group Users Audit Trail";
      this.staticAuditTrailComponent.triggerTrail(group_or_user_or_type);
    } else {
      this.message.tableOrView_Name = "QMS_GROUP_DETAIL_TYPE_SETTINGS_AU_VW";
      this.message.columnList_DB = "CREATED_TS,END_TS,ACTION_FLAG,TYPE,TO_BE_STARTED_IN_DAYS,TO_BE_CLOSED_IN_DAYS,RECALCULATE_CLOSURE_DATE_WHEN_ACTIVITY_STARTS,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER,UPDATE_REASON,DELETED_BY_USER,DELETED_REASON";
      this.message.columnList_UI = "Created Timestamp,End Timestamp,Action,Type,To Be Started In Days,To Be Closed In Days,Recalculate Closure Date When Activity Starts,Created On,Created By User,Updated On,Updated By User,Update Reason,Deleted By,Deleted Reason";
      this.message.whereClause_AU = viewType == 'overAll' ? " AND GROUP_ID = " + this.message.masterDetails[0].GROUP_ID + " AND GROUP_DETAIL_ID = " + this.onClickedGroupDetailId : " AND GROUP_ID = " + group_or_user_or_type.groupId + " AND GROUP_DETAIL_ID = " + group_or_user_or_type.groupDetailId + " AND SETTINGS_ID = " + group_or_user_or_type.settingsId;
      this.message.columnList_Report = "Created Timestamp,End Timestamp,Action,Type,To Be Started In Days,To Be Closed In Days,Recalculate Closure Date When Activity Starts,Created On,Created By User,Updated On,Updated By User,Update Reason,Deleted By,Deleted Reason";
      this.message.whereClause_Report = viewType == 'overAll' ? " WHERE GROUP_ID = " + this.message.masterDetails[0].GROUP_ID + " AND GROUP_DETAIL_ID = " + this.onClickedGroupDetailId : " WHERE GROUP_ID = " + group_or_user_or_type.groupId + " AND GROUP_DETAIL_ID = " + group_or_user_or_type.groupDetailId + " AND SETTINGS_ID = " + group_or_user_or_type.settingsId;
      this.message.report_And_Popup_Name = "Quality Group Detail " + this.titleOfQmsGroupDetailSetting + " Type Audit Trail";
      this.staticAuditTrailComponent.triggerTrail(group_or_user_or_type);
    }
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(grid: any, reportType: string) {
    if (grid == 'DETAIL') {
      this.excelPdf.reportObj = this.reportObj;
      this.excelPdf.reportType = 'Dynamic';
      this.excelPdf.reportName = 'Quality Group Details Report';
      this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
      this.excelPdfComponent.openReportPopup(reportType);
    } else if (grid == 'USER') {
      this.excelPdf.tableOrView_Name = "QMS_GROUP_USERS_VW";
      this.excelPdf.columnList_DB = "USER_NAME,FIRST_NAME,LAST_NAME,EMAIL_ADDRESS,DEPARTMENT,DESIGNATION,QMS_ROLES,IS_ACTIVE,IS_USER_ACTIVE,INACTIVATE_REASON,ASSIGNED_ON,ASSIGNED_BY_USER,UPDATED_ON,UPDATED_BY_USER,UPDATE_REASON";
      this.excelPdf.columnList_Report = "User Name,First Name,Last Name,Email Address,Department,Designation,QMS Roles,Is Active,Is User Active,Inactivate Reason,Assigned On,Assigned By User, Updated On, Updated By, Update Reason";
      this.excelPdf.whereClause_Report = " WHERE GROUP_ID = " + this.message.masterDetails[0].GROUP_ID + " AND GROUP_DETAIL_ID = " + this.selectedGroupDetailId;
      this.excelPdf.reportType = 'Static';
      this.excelPdf.reportName = "Quality Group Users Report";
      this.excelPdf.dropDown = this.excelPdf.columnList_Report?.split(',');
      this.excelPdfComponent.openReportPopup(reportType);
    } else {
      this.excelPdf.tableOrView_Name = "QMS_GROUP_DETAIL_TYPE_SETTINGS_VW";
      this.excelPdf.columnList_DB = "TYPE,TO_BE_STARTED_IN_DAYS,TO_BE_CLOSED_IN_DAYS,RECALCULATE_CLOSURE_DATE_WHEN_ACTIVITY_STARTS,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER,UPDATE_REASON";
      this.excelPdf.columnList_Report = "Type,To Be Started In Days,To Be Closed In Days,Recalculate Closure Date When Activity Starts,Created On,Created By,Updated On,Updated By,Update Reason";
      this.excelPdf.whereClause_Report = " WHERE GROUP_ID = " + this.message.masterDetails[0].GROUP_ID + " AND GROUP_DETAIL_ID = " + this.onClickedGroupDetailId;
      this.excelPdf.reportType = 'Static';
      this.excelPdf.reportName = "Quality Group Detail " + this.titleOfQmsGroupDetailSetting + " Type Report";
      this.excelPdf.dropDown = this.excelPdf.columnList_Report?.split(',');
      this.excelPdfComponent.openReportPopup(reportType);
    }

  }


  modulesearchTxt: any;
  onModuleSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (item) {
          this.isProcessing = true;
          this.selectedmoduleValue = item.valueExp;
          this.modulevalueexp = item.valueExp;
          this.selectfinalGenStage = null;
          if (item.valueExp) {

            this.appService.getoneQmsskipstageOptionsVw(item.valueExp).subscribe((response: any) => {
              this.skipStageList = response;
              this.selectBoxeForskipStageValue();
              this.isProcessing = false;
            });
            this.getActivityStatusList();
            this.appService.getoneQmsFinalNoGenerationStageOptionsVw(item.valueExp).subscribe((response: any) => {
              this.finalStageList = response;
              this.selectBoxeForfinalStageValue();
              this.isProcessing = false;
            });

            this.getCheckListTemplate(item.valueExp);

            this.isForAuditCategory = item.displayExp === 'Audit';
          }

          if (this.moduleValueRequiredMsg != undefined) {
            this.moduleValueRequiredMsg.style.display = 'none';
          }
        } else {
          this.qmsGroupsFieldData.modules = [];
          this.getActivityStatusList();
        }
      } else {
        this.selectedmoduleValue = undefined;
        if (this.moduleValueRequiredMsg != undefined) {
          this.moduleValueRequiredMsg.style.display = 'none';
        }
        this.getActivityStatusList();

      }

    }
  }

  masterpageDashboardsearchTxt: any;
  onMasterpageDashboardSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (item) {
          this.selectedmasterpageDashboard = item.valueExp;
        } else {
          this.selectedmasterpageDashboard = null;

        }
      }

    }
  }

  @ViewChild('modules') modules: MatSelect;
  @ViewChild('skipStages') skipStages: MatSelect;
  @ViewChild('qualityRoles') qualityRoles: MatSelect;
  @ViewChild('status') status: MatSelect;

  isAllModulesSelected = false;
  isSkipstageSelected = false;
  isQmsRoleSelected = false;
  isAllNotificationSelected = false;
  toggleAllSelection(value: any) {
    if (value == 'modules') {
      if (this.moduleValueRequiredMsg != undefined) {
        this.moduleValueRequiredMsg.style.display = 'none';
      }
      if (this.isAllModulesSelected) this.modules.options.forEach((item: MatOption) => item.select());
      else this.modules.options.forEach((item: MatOption) => item.deselect());
    } else if (value == 'skipStages') {
      if (this.isSkipstageSelected) this.skipStages.options.forEach((item: MatOption) => item.select());
      else this.skipStages.options.forEach((item: MatOption) => item.deselect());
    } else if (value == 'qualityRoles') {
      if (this.isQmsRoleSelected) this.qualityRoles.options.forEach((item: MatOption) => item.select());
      else this.qualityRoles.options.forEach((item: MatOption) => item.deselect());
    } else if (value == 'status') {
      if (this.isAllNotificationSelected) this.status.options.forEach((item: MatOption) => item.select());
      else this.status.options.forEach((item: MatOption) => item.deselect());
    }

  }

  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  }
  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  modulesSearchText: any = "";

  onModulesSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.moduleValueRequiredMsg != undefined) {
        this.moduleValueRequiredMsg.style.display = 'none';
      }
      setTimeout(() => {
        this.isAllModulesSelected = this.qmsGroupsModuleValueDropdown.length == this.selectedQmsGroupsModuleValue.length;
      })
      if (!item) {
        event.source.value = null;
        this.qmsGroupsFieldData.modules = [];
      }
    }
  }
  skipstagesearchTxt: any;
  onDocTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.isSkipstageSelected = this.skipstageValueDropdown.length == this.selectDocTypeName.length;
      })
    }
    this.finalNoGenerationStageRequiredMsg = document.getElementById('finalNoGenerationStage-required-msg') as HTMLInputElement;
    if (this.finalNoGenerationStageRequiredMsg != undefined) {
      this.finalNoGenerationStageRequiredMsg.style.display = 'none';
    }
  }

  qualityRolesSearchText: any;
  statusSearchText: any;
  onQualityRolesSelectAll(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.isQmsRoleSelected = this.activityStatusDropdown.length == this.selectedQmsRole.length;
      })
      if (this.qmsRolesValueRequiredMsg != undefined) {
        this.qmsRolesValueRequiredMsg.style.display = 'none';
      }
    }
  }

  onStatusSelectAll(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        // ✅ Compare the number of selected items with total available
        this.isAllNotificationSelected =
          this.activityStatusDropdown.length === this.selectedNotificationStatuses.length;
      });
    }
  }



  finalNoGenStagesearchTxt: any;
  onFinalNoGenStageSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectfinalGenStage = item.valueExp;
        if (this.finalNoGenerationStageRequiredMsg != undefined) {
          this.finalNoGenerationStageRequiredMsg.style.display = 'none';
        }
      } else {
        this.selectfinalGenStage = undefined;
      }
    }

  }


  designationsearchTxt: any;
  onDesignationSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.searchByDesignationCode = item.valueExp;
      } else {
        this.searchByDesignationCode = undefined;
      }
    }

  }

  departmentsearchTxt: any;
  onDepartmentSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.searchByDepartmentCode = item.valueExp;

      } else {
        this.searchByDepartmentCode = undefined;
      }
    }

  }

  usersearchTxt: any;
  onQmsUserSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectedQmsUser = item.valueExp;
        if (this.usersValueRequiredMsg != undefined) {
          this.usersValueRequiredMsg.style.display = 'none';
        }
      } else {
        this.selectedQmsUser = undefined;

      }
    }

  }


  typesearchTxt: any;
  onTypeValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectedTypeValue = item.valueExp;
        if (this.typeValueRequiredMsg != undefined) {
          this.typeValueRequiredMsg.style.display = 'none';
        }
      } else {
        this.selectedTypeValue = undefined;

      }
    }

  }


  openFlexifieldsPopup(data: any) {
    this.qmsGroupDetailsFieldData = data;
    this.appService.executionSetupId = this.qmsGroupDetailsFieldData.groupId;
    this.appService.flexiFieldModule = "qmsGroup";
    this.appService.qmsGroupData = data;
    this.visibleFlexifieldsPopup = this.dialog.open(this.flexifieldsPopup, this.flexifieldsPopupConfig);
  }

  cancelFlexifieldsPopup() {
    this.visibleFlexifieldsPopup.close();
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, null, 0)
  }

  onChildValueEmitted() {
    this.getcallMethod();
  };

  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages
  groupUsersMaxSize = 3;
  groupUsersCollectionSize: number;
  groupUsersPerPage = 10;
  groupUsersCalculateTotalPages: number;
  groupUsersRowText = "Rows";
  groupUsersShowingRowsText = "Showing rows";
  private readonly users: any[];
  groupUsersPager: any = {};
  groupUsersPagedItems: any[];

  groupUsersSetPage(page: number, targetPage: number) {
    if (page < 1 || page > this.groupUsersPager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.groupUsersPager = this.paginationService.getPager(this.qmsGroupsUsersList.length, page, this.groupUsersPerPage, targetPage);
    this.groupUsersPagedItems = this.qmsGroupsUsersList.slice(this.groupUsersPager.startIndex, this.groupUsersPager.endIndex + 1);
  }

  groupUsersPaginationCall(value: number) {
    this.groupUsersPerPage = value;
    this.groupUsersSetPage(this.groupUsersPager.currentPage, 0);
  }

  setPagedOrSearch(page: number, targetPage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }
    if (this.qmsGroupsUsersList.length > 0) {
      this.groupUsersPager = this.paginationService.getPager(this.qmsGroupsUsersList.length, page, this.groupUsersPerPage, targetPage);
      this.groupUsersPagedItems = this.qmsGroupsUsersList.slice(this.groupUsersPager.startIndex, this.groupUsersPager.endIndex + 1);
    } else {
      this.groupUsersPagedItems = [];
    }
  }

  getGroupUsers(groupId: any) {
    this.qmsGroupsUsersList = [];
    this.isProcessing = true;
    this.appService.getQmsGroupUsersVwByGroupDetailId(groupId).subscribe({
      next: (groupUsers: any) => {
        if (groupUsers.length) {
          this.qmsGroupsUsersList = groupUsers;
          this.groupUsersCollectionSize = this.qmsGroupsUsersList.length;
          this.groupUsersCalculateTotalPages = this.collectionSize / this.perPage;
          this.groupUsersPager.totalPages = undefined;
          this.groupUsersSetPage(1, 0);
          this.isProcessing = false;
        } else {
          this.qmsGroupsUsersList = [];
          this.groupUsersCollectionSize = 0;
          this.groupUsersCalculateTotalPages = 0;
          this.groupUsersPagedItems = [];
          this.isProcessing = false;
        }
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  columnSearch(column: string, event: Event, dataTYpe: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.groupUsersPagedItems = this.qmsGroupsUsersList.slice(this.groupUsersPager.startIndex, this.groupUsersPager.endIndex + 1);
    } else {
      this.groupUsersPagedItems = this.qmsGroupsUsersList.filter((item: any) => {
        const columnValue = item[column];
        if (dataTYpe === 'date') {
          if (!columnValue) {
            return false;
          }
          const formattedDate = this.datePipe.transform(columnValue, 'dd-MMM-yyyy');
          return formattedDate?.toString().toLowerCase().includes(filter) ?? false;
        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        return false;
      });
    }
  }

  dynamicLabel: any = null;
  label: any = [];
  groupInfo: any = null;
  dynamicLabelCall() {
    this.isProcessing = true;

    const qmsGroupData = {
      tableName: 'QMS_GROUPS_VW',
      moduleName: null,
      gridName: 'QMS_GROUP',
      groupId: 0,
    };

    const groupUsersData = {
      tableName: this.reportObj.tableOrViewName,
      moduleName: null,
      gridName: this.reportObj.gridName,
      groupId: 0,
    };

    const qmsGroupColumn = this.appService.getreorderGirdColumnList(qmsGroupData);
    const groupUsersColumn = this.appService.getreorderGirdColumnList(groupUsersData);

    forkJoin([qmsGroupColumn, groupUsersColumn]).subscribe({
      next: (result: any) => {
        this.isProcessing = false;

        this.groupInfo = result[0].reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});

        this.dynamicLabel = result[1].reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
      },
      error: () => {
        this.isProcessing = false;
      }
    });
  }

  public viewCheckList(): boolean {
    const x: boolean = this.selectedmoduleValue && !(this.selectDocTypeName.includes('Review') &&
      this.selectDocTypeName.includes('Approve') &&
      this.selectDocTypeName.includes('Closure Review') &&
      this.selectDocTypeName.includes('Closure Approve'));

    if (!x) this.qmsGroupDetailsFieldData.enableCheckList = false;

    return x;
  }
}
